import type { Dict } from "./en";

const es: Dict = {
  grid: {
    controls: { group: "Controles de zoom de la cuadrícula", zoomIn: "Acercar", zoomOut: "Alejar", fit: "Ajustar la cuadrícula a la vista" },
    hud: { aria: "HUD de coordenadas de la cuadrícula", instrument: "Instrumento", xy: "X · Y", zoom: "Zoom", grid: "Cuadrícula", chain: "Red" },
    legend: {
      gridZero: { label: "Grid Zero", desc: "Núcleo central bloqueado" },
      vipCore: { label: "VIP Core", desc: "Anillo central prémium · vendible" },
      premium: { label: "Premium", desc: "Bulevares y anillo interior" },
      reserve: { label: "Reserva", desc: "4 zonas reservadas bloqueadas" },
      standard: { label: "Standard", desc: "Territorio general" },
    },
    loading: { initializing: "Inicializando territorio" },
    mode: { aria: "Modo de interacción de la cuadrícula", select: "Seleccionar", selectHint: "Dibujar rectángulo", inspect: "Inspeccionar", inspectHint: "Clic en parcelas", itemAria: "Modo {label} — {hint}" },
    enter3d: { title: "Entrar en 3D", fallbackName: "territorio" },
    panel: {
      parcelProfileAria: "Perfil de parcela", parcelProfileTitle: "Perfil de parcela", parcel: "Parcela",
      territoryName: "Nombre del territorio", owner: "Propietario", position: "Posición", size: "Tamaño", slots: "Espacios", zone: "Zona",
      claimBlock: "Bloque de claim", claimTx: "Tx de claim", selectTerritory: "Seleccionar territorio",
      emptySelection: "La celda no tiene parcela. Haz clic en un territorio propio para ver su dossier.",
      emptyDefault: "Haz clic en una parcela de la cuadrícula para ver propiedad, coordenadas e identidad on-chain.",
      contextAria: "Panel de contexto", panelAria: "Panel", closePanel: "Cerrar panel", snapshot: "Snapshot",
      titleArtwork: "Obra", titleSelection: "Selección", titleContext: "Contexto",
      parcelNum: "Parcela n.º {id}", selectionSize: "{w} × {h} · {slots} ranuras", drawRectHint: "Dibuja un rectángulo en la cuadrícula",
    },
    context: {
      emptyTitle: "Ningún territorio seleccionado",
      emptyDesc: "Dibuja un rectángulo en la cuadrícula para previsualizar ranuras, zona, nivel de escasez y precio.",
    },
    detail: {
      fetchFailed: "Error al obtener los detalles: {error}",
      conflict: "Conflicto de invariante de datos en esta celda: {count} parcelas se superponen. Selección suprimida.",
      cellOutside: "Fuera de la cuadrícula ({x}, {y})",
      cellLoadingMap: "Cargando datos del mapa…",
      cellConfirming: "Confirmando celda ({x}, {y})…",
      cellEmpty: "Celda ({x}, {y}): ninguna parcela indexada en esta celda (al bloque {block})",
      cellConfirmError: "No se pudo confirmar el estado actual de la celda.",
      chainMismatch: "Visor no disponible por discrepancia de red.",
      indexerNotReady: "Indexador no listo — aún sin snapshot.",
      clickHint: "Haz clic en una parcela para ver los detalles.",
      zoneClassifying: "Clasificando…",
      zoneUnavailable: "No disponible",
      zoneSaleLocked: "· venta bloqueada",
      zoneMixed: "· zona mixta",
    },
    toolbar: {
      territory: "Territorio",
      scrollToZoom: "desplaza para hacer zoom",
      menu: "Menú",
      openNav: "Abrir navegación",
      hideNav: "Ocultar navegación",
      revealAreas: "Mostrar áreas",
      revealAreasAria: "Mostrar las zonas del territorio",
      zonesUnavailable: "Mapa de zonas no disponible — reintentando automáticamente",
      zonesRetry: "Reintentar",
      showDragArtwork: "Mostrar y arrastrar obra",
      showDragArtworkAria: "Mostrar y arrastrar obra",
      showDragArtworkTitle: "Muestra mi obra en la cuadrícula y arrástrala a otra parcela",
      loading: "Cargando…",
      myTerritories: "Mis territorios",
    },
    status: {
      live: "EN VIVO", cached: "CACHÉ", chain: "RED",
      liveTitle: "En vivo · sincronizado",
      cachedTitle: "Mostrando el último snapshot conocido",
      chainTitle: "Discrepancia de red — datos del visor suprimidos",
    },
    artworkMsg: {
      none: "Aún no tienes Frozen Artworks.",
      noPlaced: "No hay obras colocadas para mover.",
      connectWallet: "Conecta tu wallet para mover tus obras.",
    },
    slotCount: {
      slots: "ranuras",
      selectedTitle: "{slots} ranuras seleccionadas ({w} × {h})",
    },
    bottomSheet: { aria: "Panel inferior", dragOpen: "Arrastra para redimensionar o plegar", handle: "Asa del panel" },
    stats: {
      networkStatus: "Estado de la red", live: "En vivo", offline: "Sin conexión", syncing: "Sincronizando", chain: "Red",
      parcelsClaimed: "Parcelas reclamadas", onChain: "on-chain", cellsAllocated: "Celdas asignadas",
      finiteWorld: "{pct}% del mundo finito", indexerHead: "Cabeza del indexador", finalized: "finalizado #{block}",
    },
    capacity: {
      territory: "Territorio", resolving: "Resolviendo territorio…", unavailable: "Capacidad del territorio no disponible",
      area: "Área del territorio", publishability: "Publicabilidad", publishable: "Publicable",
      notPublishable: "No publicable · Mínimo {min} u²", gpCapacity: "Capacidad GP", propertyUnits: "Unidades de propiedad",
    },
    artworks: {
      title: "Obras en esta tierra", scanning: "Escaneando…",
      empty: "Aún no hay Frozen Artworks colocadas en esta tierra.", untitled: "Obra sin título", view: "Ver →",
    },
    zoomHint: {
      copy: "Haz zoom para explorar The Grid. Con el zoom máximo, descubre lo que los creadores han publicado en cada parcela.",
      controlDesktop: "Rueda o trackpad para hacer zoom",
      controlMobile: "Pellizca para hacer zoom",
      dontShow: "No mostrar de nuevo",
      close: "Cerrar",
      enteringParcels: "Estás entrando en las parcelas",
    },
  },
  nav: {
    marketplace: "Marketplace",
    feed: "Feed",
    rent: "RENT",
    overview: "Resumen",
    about: "El Proyecto",
    howItWorks: "Cómo Funciona",
    explore: "Explorar",
    creators: "Creadores y Marcas",
    creatorsShort: "Creadores",
    territory: "Territorio",
    profile: "Perfil",
    enterGrid: "Entra en la Grid",
    signIn: "Iniciar sesión",
    navigate: "Navegar",
    purchaseBadge: "Compra",
    openMenuAria: "Abrir el menú de navegación",
    closeMenuAria: "Cerrar el menú de navegación",
    primaryAria: "Principal",
    howItWorksHintAria: "¿Nuevo aquí? Descubre cómo funciona THE GRID",
  },
  lang: { ariaLabel: "Idioma", menuLabel: "Elegir idioma" },
  wallet: {
    connect: "Conectar",
    connecting: "Conectando…",
    myTerritories: "Mis territorios",
    sessionDetails: "Detalles de sesión",
    disconnect: "Desconectar",
  },
  auth: {
    title: "Sesión",
    subtitle: "Base de autenticación con wallet · SIWE + EIP-1271/6492",
    walletLabel: "Wallet",
    sessionLabel: "Sesión",
    connectPrompt: "Conecta una wallet desde la navegación superior para habilitar el inicio de sesión.",
    loading: "Cargando…",
    signedInAs: "Sesión iniciada como {wallet}",
    expires: "expira: {date}",
    signOut: "Cerrar sesión",
    signIn: "Inicia sesión con Ethereum",
    chain: "red: {name} ({id})",
    status: {
      requestingNonce: "Solicitando nonce…",
      requestingSignature: "Solicitando firma a la wallet…",
      verifying: "Verificando la firma…",
      signedIn: "Sesión iniciada como {wallet} (ruta: {path})",
      signedOut: "Sesión cerrada",
    },
  },
  home: {
    hero: {
      eyebrow: "// UN MUNDO. POSIBILIDADES FINITAS.",
      paragraph:
        "Un único territorio finito de un millón de celdas. Explora, reclama y posee on-chain. Cada parcela se acuña desde el mismo registro, asignada una sola vez, para siempre.",
      enterGrid: "Entra en la Grid",
      scrollLine1: "Desplázate para",
      scrollLine2: "Explorar",
      scrollAria: "Desplázate para explorar",
    },
    instrument: {
      title: "Instrumento",
      labels: { grid: "CUADRÍCULA", chain: "RED", maxZoom: "MAX·Z", auth: "AUTH" },
    },
    callouts: {
      gridZero: { title: "Grid Zero", body: "Núcleo del territorio" },
      lattice: { title: "Retícula de datos", body: "Límites de zona on-chain" },
      cells: { label: "Celdas · Finitas" },
    },
    features: [
      { title: "Finito por Diseño", body: "1.000.000 de celdas. Nunca más." },
      { title: "Construido sobre Base", body: "Territorio on-chain · hoy en Base Sepolia." },
      { title: "Explorable por Todos", body: "Lee el mapa sin una wallet." },
      { title: "Propiedad del Wallet", body: "SIWE · EIP-1271 · EIP-6492 verificados." },
    ],
    story: {
      eyebrow: "Nuestra Historia",
      titleLine1: "UNA NUEVA ERA",
      titleLine2: "DE LA",
      titleHighlight: "PROPIEDAD",
      paragraph:
        "La Grid nació de una idea simple: un territorio digital finito por construcción, cuyos límites viven en el registro — no en la página de marketing. Lo que posees aquí, la cadena lo recuerda.",
    },
    roadmap: {
      phaseLabel: "Fase",
      eyebrow: "Cronología",
      phasesLive: "{live} de {total} fases activas",
      title: "LO QUE ESTÁ LISTO. LO QUE VIENE.",
      paragraph:
        "Un mapa honesto, leído directamente desde Base. Cimientos y Propiedad están activos hoy — reclama, crea, publica y hazte descubrir ahora mismo. Ahora estamos en la fase de pulido y correcciones finales; el próximo gran hito es el Mainnet, y aparecerá aquí solo cuando sea el registro, no el texto, quien lo haga real.",
      status: { live: "Activo", next: "En curso", later: "Planeado" },
      phases: [
        {
          title: "Cimientos",
          items: [
            "Territorio canónico de 1.000.000 de celdas en Base",
            "Indexer + reconciler on-chain activos",
            "Autenticación de wallet SIWE · EIP-1271 · EIP-6492",
            "Exploración pública, sin wallet",
          ],
        },
        {
          title: "Propiedad y Creación",
          items: [
            "Reclamo de parcelas y pago en USDC en Base",
            "Canvas para creadores — enlaces, redes, medios, plantillas",
            "Capa voxel 3D opcional",
            "Publicación + descubrimiento honesto en Explore",
          ],
        },
        {
          title: "Pulido final",
          items: [
            "Correcciones de aceptación y pulido de UX",
            "Cobertura multilingüe completa",
            "Endurecimiento y QA final antes del lanzamiento",
            "Página de vista previa de Parcel RENT · lanzamiento previsto Q1 2027",
          ],
        },
        {
          title: "Mainnet",
          items: [
            "Despliegue en Mainnet (Base)",
            "Ofertas, mercado secundario y actividad",
            "Certificados y verificación de creadores",
            "APIs públicas y extensiones",
          ],
        },
      ],
    },
    cta: {
      eyebrow: "Entra",
      titlePrefix: "ELIGE TU",
      titleHighlight: "TERRITORIO",
      paragraph:
        "El mapa que exploraste es público. La propiedad no. Inicia sesión con tu wallet para tomar tu posición — el registro la recordará.",
      exploreGrid: "Explora la Grid",
      signIn: "Inicia sesión con Ethereum",
    },
    footer: {
      legalAria: "Legal",
      legalToggle: "Legal y políticas",
      walletAuth: "Autenticado con wallet",
      territoryData: "Datos del territorio · leídos on-chain",
    },
    slidedots: {
      aria: "Navegación de secciones",
      overview: "Resumen",
      story: "Historia",
      territory: "Territorio",
      roadmap: "Roadmap",
      enter: "Entrar",
    },
  },
  about: {
    eyebrow: "El Manifiesto",
    titleLine1: "UN MUNDO",
    titleHighlight: "FINITO.",
    intro:
      "THE GRID es un único territorio digital finito de un millón de celdas, asignado una sola vez y poseído on-chain. Esto es lo que creemos y lo que el producto realmente hace — nada más, nada inventado.",
    principles: [
      {
        title: "Finito por construcción",
        body: "Un territorio. Un millón de celdas. Nunca más. Aquí la escasez no es una decisión de marketing — está escrita en el contrato y no se puede inflar.",
      },
      {
        title: "La propiedad vive on-chain",
        body: "Una parcela es un activo on-chain en Base. Lo que posees lo registra el ledger, no nosotros. Los límites de tu territorio son verificables, no prometidos.",
      },
      {
        title: "Público por defecto",
        body: "Cualquiera puede leer el mapa — sin wallet, sin registro. El descubrimiento es abierto. La propiedad es lo único que exige demostrar quién eres.",
      },
      {
        title: "Un lienzo, no una valla",
        body: "Cada territorio es una superficie de diseño real: texto, enlaces, redes, medios, formas y una capa 3D opcional, todo dentro de un presupuesto honesto de Grid-Power derivado de tu terreno.",
      },
      {
        title: "Tu identidad, verificada",
        body: "Sign-In With Ethereum con wallets EOA y de smart-contract (EIP-1271 / EIP-6492). Nunca custodiamos tus claves ni movemos tus fondos.",
      },
      {
        title: "Hecho para durar",
        body: "El contenido publicado es una instantánea duradera, separada de tu borrador de trabajo. Editar después nunca rompe lo que el público ya ve hasta que republicas.",
      },
    ],
  },
  how: {
    eyebrow: "El Recorrido",
    titleLine1: "DEL MAPA",
    titleLine2: "A LA PROPIEDAD.",
    intro:
      "Seis pasos reales, cada uno respaldado por una función ya disponible. Este es todo el ciclo — explora, reclama, diseña, publica y hazte descubrir.",
    stepLabel: "PASO {n}",
    toggle: { show: "Cómo funciona", hide: "Ocultar", aria: "Mostrar una explicación simple paso a paso" },
    steps: [
      {
        title: "Explora el mapa",
        body: "Abre el Territorio y muévete por la Grid finita de 1000×1000. Haz zoom en cualquier parcela para ver quién posee qué — sin necesidad de wallet.",
        detail: {
          intro: "Mirar alrededor es totalmente gratis y público — sin wallet, sin cuenta.",
          points: [
            "Abre Territorio desde el menú superior para ver todo el mapa: una sola cuadrícula de 1.000.000 de pequeños cuadrados (celdas).",
            "Arrastra para moverte, desplaza para hacer zoom. Haz zoom en cualquier zona para ver qué terreno está ocupado y qué pusieron sus dueños.",
            "Aquí nada te pide iniciar sesión — leer el mapa siempre está abierto a todos.",
          ],
        },
      },
      {
        title: "Reclama tu parcela",
        body: "Dibuja un rectángulo sobre terreno libre y recláma­lo en Base. La propiedad se acuña on-chain — tu posición la registra el ledger, no nosotros.",
        detail: {
          intro: "\"Reclamar\" significa convertirte en dueño de un rectángulo de celdas libres. La propiedad se escribe en Base, una blockchain pública.",
          points: [
            "Necesitarás una wallet cripto — una pequeña app gratuita del navegador que demuestra que eres tú y aprueba las acciones.",
            "Hoy THE GRID funciona en Base Sepolia, una red de prueba, así que usas USDC de prueba — no dinero real.",
            "En el mapa, dibuja un rectángulo sobre terreno libre y confirma. Tu wallet firma y la parcela se acuña para ti.",
          ],
        },
      },
      {
        title: "Diseña tu Canvas",
        body: "Convierte tu territorio en una página real: títulos, enlaces, redes, contactos, medios y formas — o empieza desde una de las seis plantillas premium. Todo cabe en un presupuesto honesto de Grid-Power derivado del área de tu terreno.",
        detail: {
          intro: "Tu parcela es una página en blanco que tú controlas. Rellénala, o empieza desde una plantilla lista.",
          points: [
            "Añade títulos, enlaces, botones sociales, contactos, imágenes, video y formas simples.",
            "¿Prefieres un empujón inicial? Carga una de las seis plantillas premium y ajusta cada detalle.",
            "Cada parcela tiene un presupuesto de Grid-Power según su tamaño — más terreno te deja colocar más. Mantiene las páginas honestas y rápidas.",
          ],
        },
      },
      {
        title: "Añade una capa 3D (opcional)",
        body: "Da profundidad a tu territorio con una escena voxel en la que los visitantes pueden entrar al hacer zoom. Totalmente opcional — un Canvas plano también es un resultado de primera.",
        detail: {
          intro: "Sobre la página plana puedes añadir una pequeña escena 3D hecha de bloques (voxels).",
          points: [
            "Los visitantes entran en la escena al hacer zoom profundo en tu parcela.",
            "Es totalmente opcional — nunca tienes que crear una.",
            "Un Canvas plano sin 3D es un resultado completo y de primera.",
          ],
        },
      },
      {
        title: "Publica",
        body: "Publicar toma una instantánea duradera de tu borrador guardado. Sigue editando en privado — el público ve exactamente lo que publicaste hasta que republiques.",
        detail: {
          intro: "Publicar crea una copia pública de tu trabajo — mientras tu borrador privado sigue siendo tuyo para editar.",
          points: [
            "Toma una instantánea duradera de tu borrador guardado y se la muestra al mundo.",
            "Puedes seguir editando en privado; los visitantes siguen viendo la versión publicada.",
            "Nada de lo que cambies se hace público hasta que publiques de nuevo.",
          ],
        },
      },
      {
        title: "Hazte descubrir",
        body: "Cada publicación válida y actual aparece en Explore, de la más reciente primero — sin pay-to-rank, sin trending falso. Propiedad real, contenido real, orden honesto.",
        detail: {
          intro: "Una vez publicado, tu territorio queda listado para todos — de forma automática y justa.",
          points: [
            "Aparece en la página Explore, de los más recientes primero.",
            "No se paga por posicionarse más arriba y no hay \"trending\" falso.",
            "Propiedad real, contenido real, orden honesto.",
          ],
        },
      },
    ],
    before: {
      eyebrow: "Empieza aquí",
      title: "Antes de empezar",
      intro: "Para mirar alrededor no necesitas casi nada. Solo necesitas una wallet cuando decides poseer terreno.",
      items: [
        { title: "Para explorar: nada", body: "Leer el mapa y abrir cualquier página publicada es totalmente público — sin wallet, sin registro." },
        { title: "Una wallet cripto", body: "Para reclamar y poseer necesitas una wallet: una pequeña app gratuita del navegador que demuestra que eres tú. Nunca custodiamos tus claves ni tus fondos." },
        { title: "Fondos de prueba, no dinero real", body: "Hoy THE GRID funciona en Base Sepolia, una red de prueba gratuita. Usas USDC de prueba para probarlo todo con seguridad." },
        { title: "Unos minutos", body: "Reclamar, diseñar y publicar toma minutos — no horas." },
      ],
    },
    journey: {
      eyebrow: "De principio a fin",
      title: "El recorrido completo",
      intro: "Todo el ciclo de un vistazo. Cada paso lleva naturalmente al siguiente.",
      optional: "opcional",
      steps: ["Explorar", "Reclamar", "Diseñar", "Capa 3D", "Publicar", "Hazte descubrir"],
    },
    draft: {
      eyebrow: "Dos versiones",
      title: "Borrador vs Publicado",
      intro: "Tu trabajo siempre vive en dos lugares. Entender la diferencia es todo el truco.",
      draftLabel: "Borrador",
      draftBody: "Tu copia de trabajo privada. Solo tú la ves. Edítala cuanto quieras, cuando quieras.",
      publishedLabel: "Publicado",
      publishedBody: "Una instantánea pública duradera. Es lo que ven los visitantes. No cambia hasta que publicas de nuevo.",
      takeaway: "Editar tu borrador siempre es seguro — el público sigue viendo tu última versión publicada.",
    },
    levels: {
      eyebrow: "Tres niveles de zoom",
      title: "Cómo se vive THE GRID",
      intro: "El mismo territorio revela más cuanto más cerca miras.",
      items: [
        { tag: "Zoom alejado", title: "El mapa", body: "Ve todo el territorio finito de una vez y dónde está cada cosa." },
        { tag: "Zoom acercado", title: "Una página", body: "Haz zoom en una parcela y se convierte en una página real — el Canvas del dueño con texto, enlaces y medios." },
        { tag: "Más profundo (opcional)", title: "En 3D", body: "Sigue haciendo zoom en una parcela con capa 3D y entras en su escena voxel." },
      ],
    },
    faq: {
      eyebrow: "Preguntas de principiante",
      title: "FAQ para principiantes",
      intro: "¿Nuevo en THE GRID o en Web3? Empieza aquí.",
      items: [
        { q: "¿Necesito una wallet solo para mirar?", a: "No. Explorar el mapa y abrir cualquier página publicada es totalmente público y gratis." },
        { q: "¿Qué es una \"wallet\"?", a: "Una pequeña app — a menudo una extensión del navegador — que guarda tu identidad on-chain y te permite aprobar acciones. Tú mantienes el control; nunca custodiamos tus claves ni tus fondos." },
        { q: "¿Es dinero real?", a: "Hoy no. THE GRID funciona en Base Sepolia, una red de prueba gratuita, con USDC de prueba — para que pruebes todo con seguridad." },
        { q: "¿Qué son celdas y parcelas?", a: "THE GRID es un solo mapa de 1.000.000 de pequeños cuadrados llamados celdas. Una parcela es un rectángulo de celdas que posees." },
        { q: "¿Puedo cambiar mi página después de publicar?", a: "Sí. Mantienes un borrador privado y puedes editarlo cuando quieras. El público sigue viendo tu última versión publicada hasta que publicas de nuevo." },
        { q: "¿Qué es Grid-Power?", a: "Un presupuesto simple según el tamaño de tu terreno que limita cuánto puedes colocar, manteniendo las páginas honestas y rápidas de cargar." },
      ],
    },
  },
  explore: {
    eyebrow: "Descubre",
    titleLine1: "TERRITORIOS",
    titleHighlight: "PUBLICADOS.",
    intro:
      "Territorios reales y actualmente activos en THE GRID — de los más recientes. Sin pay-to-rank, sin trending inventado, sin conteos falsos. Abre cualquiera para ver su página pública.",
    error: {
      title: "No se pudo cargar el directorio público",
      body: "El servicio de descubrimiento no está disponible ahora mismo. Inténtalo de nuevo en breve.",
      retry: "Reintentar",
    },
    empty: {
      title: "El mapa está esperando",
      body: "Todavía no se ha publicado ningún territorio. Cuando los creadores publiquen su Canvas, aparecerán aquí — de los más recientes. Podrías ser el primero.",
      claim: "Reclama tu territorio",
      how: "Cómo funciona",
    },
    liveOne: "{count} territorio activo",
    liveOther: "{count} territorios activos",
    modulesOne: "{count} módulo",
    modulesOther: "{count} módulos",
    untitled: "Territorio sin título",
    view: "Ver territorio",
    badgeMedia: "Medios",
  },
  creators: {
    eyebrow: "Creadores y Marcas",
    titleLine1: "TU TERRITORIO,",
    titleHighlight: "TU ESCENARIO.",
    intro:
      "Hagas lo que hagas, hay un punto de partida para ello. Seis plantillas Canvas premium convierten un territorio en propiedad en una página terminada en minutos — luego editas cada píxel. Las plantillas se cargan en tu propio borrador dentro del editor; nada se publica hasta que tú lo decidas.",
    sixTemplates: "Seis plantillas premium",
    useCases: {
      creator: "Para creadores que construyen una marca personal — una identidad rotunda, bio y una sola llamada a la acción.",
      retail: "Para pequeñas tiendas y marcas — una cabecera sobre un estante de productos con una ruta clara de compra.",
      gallery: "Para artistas — la obra manda, una declaración discreta la acompaña.",
      music: "Para lanzamientos y eventos en vivo — título, fecha, lugar y un enlace directo a entradas / streaming.",
      product: "Para lanzamientos — titular, línea de apoyo, tres bloques de características y una CTA.",
      minimal: "Para el minimalismo de alta gama — contención, espacio en blanco y una sola acción pensada.",
    },
    noteBefore: "Las plantillas viven dentro del editor Canvas para un territorio que posees. Abre un territorio, pulsa ",
    noteBold: "Plantillas",
    noteAfter: ", elige un punto de partida — rellena tu borrador, y Guardar / Publicar quedan en tus manos.",
    howCta: "Cómo funciona",
  },
  rent: {
    eyebrow: "Función planificada",
    titleLine1: "PARCEL",
    titleHighlight: "RENT",
    intro: "Una forma planificada para que los propietarios de territorios alquilen solo una parte de su territorio a marcas para campañas promocionales temporales, conservando la plena propiedad de su parcela.",
    release: "Lanzamiento previsto: Q1 2027",
    status: "Aún no disponible · Vista previa informativa",
    coexist: {
      eyebrow: "Territorio compartido",
      title: "Un territorio. Dos áreas separadas.",
      body: "El propietario conserva su propio espacio e identidad. La campaña de un patrocinador viviría solo dentro del área alquilada, durante un tiempo limitado: ambas conviven una junto a la otra, sin mezclarse nunca.",
      ownerLabel: "Propietario",
      sponsorLabel: "Patrocinador",
      ownerLegend: "Área del propietario — sigue siendo del propietario",
      sponsorLegend: "Área del patrocinador — alquilada, por tiempo limitado",
      caption: "Ejemplo ilustrativo — no es un territorio ni una campaña reales",
    },
    how: {
      eyebrow: "Cómo está previsto que funcione",
      steps: [
        { title: "La propiedad se mantiene", body: "La parcela y su NFT nunca cambian de manos durante un alquiler." },
        { title: "Solo se alquila una parte", body: "El propietario elige qué área ofrecer; el resto del territorio no se toca." },
        { title: "Campañas temporales", body: "Un patrocinador solo podría publicar dentro del área aprobada, y el acceso termina cuando vence el alquiler." },
        { title: "Verificado y oficial", body: "Verificaciones de identidad previstas para los participantes de RENT y pagos a través del flujo oficial de alquiler de The Grid." },
      ],
    },
    model: {
      eyebrow: "Modelo de negocio propuesto",
      title: "Ingresos por alquiler para los propietarios. Una comisión para The Grid.",
      body: "Según el modelo propuesto, el propietario del territorio podría obtener ingresos por el área alquilada, mientras que The Grid recibiría una comisión por cada transacción oficial de alquiler.",
      cards: [
        { title: "Propietarios", body: "Posibles ingresos por alquiler de una parte del territorio, sin vender la parcela." },
        { title: "Marcas", body: "Una presencia promocional temporal dentro de territorios de creadores seleccionados." },
        { title: "The Grid", body: "Una comisión sobre las transacciones oficiales de alquiler." },
      ],
      note: "Aún no se han definido los niveles de comisión, los precios ni las condiciones de alquiler.",
    },
    disclaimer: "Parcel RENT es una función planificada y actualmente no está disponible. Hoy no es posible reservar, pagar ni alquilar. Los detalles, requisitos, precios y plazos de lanzamiento pueden cambiar; no se garantizan ganancias, tráfico ni resultados.",
  },
  shellCta: {
    title: "El mapa es público. La propiedad no.",
    body: "Explora libremente cada territorio publicado. Cuando estés listo para reclamar una posición, inicia sesión con tu wallet — el registro la recordará.",
    explore: "Explorar territorios",
    enterGrid: "Entra en la Grid",
  },
  onboarding: {
    profileEntry: { eyebrow: "Configuración guiada" },
    eyebrow: "Configuración guiada",
    title: "Lanza tu territorio",
    intro: "Un camino guiado de cero a un territorio publicado. Nada es obligatorio — sal cuando quieras y retoma donde lo dejaste. Cada paso te lleva a la herramienta real, y tu progreso se guarda.",
    authRequired: {
      title: "Inicia sesión para empezar la guía",
      body: "La configuración guiada está ligada a tu wallet para guardar tu progreso. Conectar una wallet no basta — se requiere una sesión firmada.",
      cta: "Iniciar sesión con Ethereum",
    },
    loading: "Cargando tu guía…",
    error: {
      title: "No se pudo cargar tu guía",
      body: "El servicio de guía no está disponible ahora. Inténtalo de nuevo en breve.",
      retry: "Reintentar",
    },
    progress: {
      label: "Paso {n} de {total}",
      complete: "{done} de {total} hechos",
      statusDone: "Hecho",
      statusNow: "Ahora",
      statusNext: "Siguiente",
      statusLocked: "Después",
    },
    restart: "Reiniciar la guía",
    restartConfirm: "¿Reiniciar la guía? Esto restablece solo tu progreso guiado — tus territorios, borradores y publicaciones nunca se tocan.",
    ownershipLost: "El territorio que seleccionaste ya no pertenece a esta wallet. Te llevamos de vuelta a la selección de territorio.",
    actions: {
      select: "Seleccionar",
    },
    personas: {
      selected: "Seleccionado",
      creator: {
        label: "Creador",
        desc: "Una marca personal, un portafolio o una identidad única y contundente con una llamada a la acción clara.",
      },
      retail: {
        label: "Negocio / Retail",
        desc: "Una tienda, producto o marca — un encabezado claro sobre lo que ofreces y una ruta para actuar.",
      },
    },
    steps: {
      persona: {
        title: "¿Quién eres?",
        body: "Dinos si eres un Creador o un Negocio. Adaptamos los puntos de partida — puedes cambiarlo en cualquier momento.",
      },
      territory: {
        title: "Consigue tu territorio",
        body: "Posee una parte de la Grid, luego elige qué territorio construirá esta guía.",
        pick: "Elige el territorio a construir",
        selectedLabel: "Construyendo",
        needLand: "Aún no posees terreno. Reclama un parcel en la Grid para empezar.",
        getLand: "Consigue terreno en la Grid",
        nameIt: "Dale un nombre a este territorio",
        loading: "Resolviendo tus territorios…",
        unavailable: "Tus datos de propiedad no se pudieron resolver ahora. Inténtalo de nuevo en breve.",
      },
      start: {
        title: "Elige cómo empezar",
        body: "Empieza con un Canvas en blanco, o carga una de las seis plantillas premium y hazla tuya. Ambas abren el editor real — nada se publica hasta que tú lo decidas.",
        blank: "Empezar en blanco",
        template: "Usar una plantilla",
        hint: "Las plantillas viven dentro del editor en \"Plantillas\".",
      },
      build: {
        title: "Construye tu territorio",
        body: "Diseña tu Canvas: identidad, medios, enlaces y contactos. Guarda tu borrador cuando te convenza — permanece privado hasta que publiques.",
        open: "Abrir el editor Canvas",
        draftSaved: "Borrador guardado",
        noDraft: "Aún no hay borrador guardado",
      },
      publish: {
        title: "Publicar",
        body: "Publicar toma un snapshot público y duradero de tu borrador guardado. Puedes seguir editando en privado; el público ve tu versión publicada hasta que vuelvas a publicar.",
        open: "Abrir publicación",
        published: "Publicado",
        notReady: "Guarda primero un borrador, luego publica desde tu territorio.",
      },
      launch: {
        title: "Lanza y crece",
        body: "Tu territorio está en vivo. Compártelo — aparece en Explore automáticamente, lo más nuevo primero, sin pago por posición.",
        viewPublic: "Ver tu página pública",
        explore: "Verlo en Explore",
        copyLink: "Copiar enlace público",
        copied: "Enlace copiado",
        locked: "Publica tu territorio para desbloquear este paso.",
      },
    },
    guide: {
      title: "Configuración guiada",
      heading: "Construye tu territorio",
      intro: "Añade tu identidad, elementos visuales y enlaces, luego guarda tu borrador.",
      items: {
        identity: "Añade tu identidad (título, eslogan)",
        media: "Añade un visual o medio",
        social: "Añade info social / contacto",
        save: "Guardar borrador",
      },
      back: "Volver a la guía",
      hide: "Ocultar guía",
    },
    entry: {
      eyebrow: "¿Nuevo por aquí?",
      title: "Lancemos tu primer territorio",
      body: "Un breve camino guiado te lleva de reclamar terreno a una página publicada. Nada es obligatorio.",
      start: "Empezar la guía",
      notNow: "Ahora no",
      resume: "Retomar la guía",
      restart: "Reiniciar la guía",
      completed: "Guía completada",
    },
    creatorsCta: {
      title: "¿Nuevo en THE GRID? Sigue el camino guiado.",
      body: "De un territorio en propiedad a una página publicada en unos pasos guiados — plantillas, construcción, publicación.",
      cta: "Empezar la configuración guiada",
    },
  },
  marketplace: {
    home: {
      eyebrow: "The Grid · Marketplace",
      title: "Posee, intercambia y colecciona las coordenadas de un mundo vivo.",
      subtitle: "Cada anuncio es autoritativo en el backend y fail-closed. Las parcelas de terreno y las obras congeladas se liquidan a través de la misma autoridad de settlement on-chain — nunca se inventa nada.",
      browseLand: "Explorar Terrenos",
      browseArtworks: "Explorar Obras",
      cardLandTitle: "Terrenos",
      cardLandDesc: "Parcelas a precio fijo con pricing autoritativo por zona y floors cross-currency.",
      cardArtworksTitle: "Obras",
      cardArtworksDesc: "Obras congeladas y colocadas, negociadas con royalties al creador y subastas en vivo.",
      cardMineTitle: "Mi Mercado",
      cardMineDesc: "Tus anuncios, ofertas hechas y recibidas, y pujas de subasta en un solo lugar.",
    },
    nav: {
      search: "Buscar",
      searchAria: "Buscar en el marketplace",
      notifications: "Notificaciones",
      notificationsCountAria: "{count} notificaciones",
    },
    search: {
      title: "Buscar en el marketplace",
      subtitle: "Parcelas · obras · direcciones",
      placeholder: "Parcel #, título de obra o dirección de wallet…",
      startTyping: "Empieza a escribir para buscar anuncios y obras.",
      noMatches: "Sin resultados para “{q}”.",
      land: "terreno",
      artwork: "obra",
      sellerPrefix: "Vendedor {addr}",
      byPrefix: "de {addr}",
      auctionSuffix: " · subasta",
    },
    notifications: {
      title: "Notificaciones",
      offersOne: "{n} oferta por revisar",
      offersMany: "{n} ofertas por revisar",
      offersDetail: "Algunos compradores han hecho ofertas sobre tus activos.",
      outbidOn: "Superado en {title}",
      anAuction: "una subasta",
      topBid: "Puja más alta {top} · tu puja {yours}",
      allCaughtUp: "Estás al día con todo.",
      markAll: "Marcar todo leído",
    },
    land: {
      sectionTitle: "Anuncios de Terreno",
      loadErrorTitle: "No se pudieron cargar los anuncios",
      loadErrorDetail: "El índice del marketplace no está disponible ahora mismo. No se modificó nada.",
      emptyNoneTitle: "Aún no hay terrenos en venta",
      emptyNoneHint: "Cuando los propietarios pongan parcelas en venta, aparecerán aquí.",
      emptyFilteredTitle: "Ningún anuncio coincide con tus filtros",
      emptyFilteredHint: "Prueba a ampliar el rango de precio o a quitar el filtro de zona.",
      slots: "{n} slots",
      filters: {
        zone: "Zona",
        price: "Precio (USDC)",
        min: "Mín",
        max: "Máx",
        minSlots: "Slots mínimos",
        any: "Cualquiera",
        sort: "Ordenar",
        clear: "Limpiar filtros",
        sortRecent: "Más recientes",
        sortPriceAsc: "Precio · de menor a mayor",
        sortPriceDesc: "Precio · de mayor a menor",
        sortSlotsDesc: "Los más grandes primero",
      },
    },
    zones: {
      all: "Todas las zonas",
      standard: "Standard",
      premium: "Premium",
      vip: "VIP",
      reserve: "Reserve",
      gridZero: "Grid Zero",
    },
    artworks: {
      loadErrorTitle: "No se pudieron cargar las obras",
      loadErrorDetail: "El índice de la galería no está disponible ahora mismo.",
      liveAuctions: "Subastas en Vivo",
      live: "{n} en vivo",
      gallery: "Galería",
      works: "{n} obras",
      emptyTitle: "Aún no hay obras",
      emptyHint: "Las obras congeladas colocadas en la Grid aparecen aquí para ofertas y subastas.",
      auction: "Subasta",
      openToOffers: "Abierta a ofertas",
      royalty: "{n}% royalty",
      by: "de {addr}",
    },
    detail: {
      backToLand: "Volver a Terrenos",
      backToArtworks: "Volver a Obras",
      listingNotFound: "Anuncio no encontrado",
      listingNotFoundDetail: "Este anuncio puede haberse vendido o retirado.",
      artworkNotFound: "Obra no encontrada",
      artworkNotFoundDetail: "Esta obra puede haber sido movida o eliminada.",
      loadingParcel: "Cargando parcel…",
      loadingArtwork: "Cargando obra…",
      seller: "Vendedor {addr}",
      creatorOwner: "de {creator} · propietario {owner}",
      slots: "Slots",
      footprint: "Huella",
      floor: "Floor",
      size: "Tamaño",
      cells: "Celdas",
      royalty: "Royalty",
      status: "Estado",
      yourListing: "Tu anuncio",
      buyNow: "Comprar ahora",
      unavailable: "No disponible",
      makeOffer: "Hacer oferta",
      viewOnGrid: "Ver en la Grid",
      sellerNote: "Eres el vendedor — la compra y las ofertas están deshabilitadas en tu propio anuncio.",
      ownerNote: "Posees esta obra — las ofertas y pujas están deshabilitadas para ti.",
      openOffers: "Ofertas Abiertas",
      noOffersParcel: "No hay ofertas abiertas sobre este parcel.",
      noOffersArtwork: "No hay ofertas abiertas sobre esta obra.",
      auctionTag: "Subasta",
      openToOffers: "Abierta a ofertas",
      currentBid: "Puja actual",
      reserve: "Reserva",
      leadingPrefix: "Liderando {addr} · ",
      noBidsYet: "Aún sin pujas · ",
      minNext: "mín siguiente {amt} {sym}",
      auctionEnded: "Subasta finalizada",
      yourAuction: "Tu subasta",
      placeBid: "Pujar",
      buyTitle: "Comprar Parcel #{id}",
      buySubtitle: "Settlement a precio fijo",
      done: "Hecho",
      cancel: "Cancelar",
      reserving: "Reservando…",
      authorizing: "Autorizando…",
      reserveAuthorize: "Reservar y autorizar",
      signInRequired: "Inicio de sesión requerido",
      connectSignIn: "Conecta tu wallet e inicia sesión →",
      settlementUnavailable: "El settlement no está disponible temporalmente — no se puede cobrar nada ahora.",
      price: "Precio",
      gridFee: "Comisión Grid",
      settlementAuthorized: "Settlement autorizado",
      settlementAuthorizedBody: "La autoridad de settlement firmó tu permit. Completa la compra desde tu wallet para finalizar on-chain.",
      authorityFloor: "Autoridad {addr} · floor {amt} {sym}",
      completePurchase: "Complete purchase",
      checkingAllowance: "Checking allowance…",
      confirmInWallet: "Confirm in your wallet…",
      approvingUsdc: "Approving USDC…",
      settlingOnchain: "Finalizing on-chain…",
      purchaseComplete: "Purchase complete",
      purchaseCompleteBody: "The LAND is now yours. Ownership and listings will refresh shortly.",
      buyFailed: "Purchase failed",
      approveRejected: "USDC approval was rejected in your wallet.",
      approveReverted: "The USDC approval transaction reverted on-chain.",
      fillRejected: "The purchase was rejected in your wallet.",
      fillReverted: "The purchase transaction reverted on-chain.",
      wrongBuyerWallet: "Connect the buyer wallet {addr} to complete the purchase.",
      makeOfferTitle: "Hacer una oferta",
      makeOfferSubtitle: "Oferta vinculante · expiración en market-time",
      submitOffer: "Enviar oferta",
      submitting: "Enviando…",
      amount: "Importe",
      expiresIn: "Expira en",
      dur1h: "1 hora",
      dur24h: "24 horas",
      dur3d: "3 días",
      dur7d: "7 días",
      placeBidTitle: "Hacer una puja",
      auctionFallback: "Subasta",
      signing: "Firmando…",
      yourBid: "Tu puja ({sym})",
      minNextBid: "Puja mínima siguiente: {amt} {sym}",
      bidPermitSigned: "Permit de puja firmado",
      bidPermitBody: "La autoridad de settlement firmó tu permit de puja. Envíalo desde tu wallet para registrar la puja on-chain.",
      antiSnipe: " Tu puja cae dentro de la ventana anti-snipe y extenderá la subasta.",
      authorityMin: "Autoridad {addr} · mín aceptado {amt} {sym}",
    },
    provenance: {
      title: "Historial / Procedencia",
      empty: "Aún no hay historial de propiedad para esta parcela.",
      resale: "Reventa",
      primaryPurchase: "Compra primaria",
      privateSale: "Venta privada",
      transfer: "Transferencia",
      from: "De",
      to: "A",
      price: "Precio",
      fee: "Comisión",
      net: "Neto",
      viewTx: "Ver tx →",
      currentNameLabel: "Nombre actual",
    },
    owner: {
      cancelPrivateSale: "Cancelar",
      cancelBlocked: "No cancelable",
      cancelUnsupportedNote: "La cancelación on-chain de la venta privada no es compatible con el contrato desplegado. Las solicitudes de cancelación fallan de forma segura y nunca modifican el registro.",
      cancelPsTitle: "Cancelar venta privada",
      cancelPsBadge: "Acción del owner",
      cancelPsWarning: "Esto solicita la cancelación on-chain de la venta privada. Solo surte efecto tras confirmarse la transacción on-chain.",
      cancelPsSuccess: "Venta privada cancelada on-chain.",
      cancelPsConfirm: "Solicitar cancelación",
      cancelPsClose: "Cerrar",
      cancelPsUnsupported: "El contrato desplegado no admite la cancelación on-chain de la venta privada. No se modificó ningún registro.",
      psStatusActive: "Activa",
      psStatusCompleted: "Completada",
      psStatusExpired: "Caducada",
      psStatusCancelled: "Cancelada",
      verifyingAccess: "Verificando acceso de owner…",
      accessDeniedTitle: "Acceso de owner requerido",
      accessDeniedHint: "Esta consola está restringida a las wallets owner en la allow-list del servidor. Inicia sesión con una wallet admin.",
      loadErrorTitle: "No se pudo cargar la Owner Console",
      loading: "Cargando Owner Console…",
      integrityTitle: "Integridad de la Supply",
      noFreeGrant: "Sin grant gratuito ✓",
      grantAnomaly: "Anomalía de grant ✕",
      supplyActiveListings: "Anuncios Activos",
      supplySoldListings: "Anuncios Vendidos",
      supplyOpenOffers: "Ofertas Abiertas",
      supplyOpenAuctions: "Subastas Abiertas",
      supplyPendingSettlements: "Settlements Pendientes",
      supplyPaidAcquisitions: "Adquisiciones Pagadas",
      zeroPriceGrants: "Grants a precio cero",
      actionsTitle: "Acciones de Owner",
      gridZeroManual: "Grid Zero manual",
      releaseLabel: "Release",
      releaseDesc: "Hacer disponible el inventario elegible. Cell-authoritative: liberadas, no efectivamente reservadas, no ocupadas.",
      relockLabel: "Relock",
      relockDesc: "Volver a bloquear inventario disponible. Nunca vuelve a bloquear celdas vendidas, ocupadas o no elegibles.",
      privateSaleLabel: "Venta Privada",
      privateSaleDesc: "Crea una venta acotada a un comprador. El precio de tier es oficial; Grid Zero es manual. El precio debe ser > 0.",
      failClosed: "Fail-closed",
      unavailable: "No disponible",
      privateSalesTitle: "Ventas Privadas",
      noPrivateSalesTitle: "No hay ventas privadas proyectadas",
      noPrivateSalesHint: "Las ventas privadas aparecen aquí una vez creadas on-chain — cancelables hasta el pending.",
      buyer: "comprador {addr}",
      perSlot: "/ slot",
      executed: "Ejecutada",
      pending: "Pendiente",
      supplyCheckTitle: "Chequeo de Supply",
      walletPlaceholder: "dirección de wallet 0x",
      checking: "Comprobando…",
      auditWallet: "Auditar wallet",
      supplyCheckFailed: "Fallo en el chequeo de supply",
      owned: "En posesión",
      paidOrigin: "Origen pagado",
      integrity: "Integridad",
      consistent: "Consistente",
      anomalies: "Anomalías",
      confirmationSuffix: "confirmación {tier}",
      tierNormal: "normal",
      tierStrong: "fuerte",
      tierMaximum: "máxima",
      failClosedBanner: "Fail-closed: {reason}. Esta acción no se puede ejecutar — no se cobra ni se inventa nada.",
      typeToProceedPre: "Escribe ",
      typeToProceedPost: " para continuar",
      ack: "Entiendo que esta es una acción de owner cell-authoritative y confirmo el objetivo y la cantidad.",
      confirmAction: "Confirmar {action}",
      submitting: "Enviando…",
      cancel: "Cancelar",
      zoneLabel: "Zona",
      slotsLabel: "Slots",
      buyerLabel: "Wallet del comprador",
      priceLabel: "Precio unitario (USDC)",
      priceHintGridZero: "Grid Zero requiere un precio unitario manual > 0.",
      priceHintTier: "El precio de tier es oficial y se aplica automáticamente.",
      actionSuccess: "Acción de owner ejecutada",
      actionSuccessBody: "{action}: {count} celdas en {zone} — registrada en el audit de owner inmutable. Sin grant gratuito, sin escritura on-chain.",
      demoScope: "Preview Demo — substrate aislado, sin escritura on-chain",
    },
    common: {
      parcelNumber: "Parcel #{id}",
      partialTag: "PARCIAL",
      close: "Cerrar",
      retry: "Reintentar",
    },
    confirm: {
      normal: "Confirma esta acción de owner cell-authoritative.",
      strong: "Esto afecta a {slots} slots (más de {threshold}). Reintroduce el número exacto de slots para continuar.",
      maximum: "GRID ZERO es el inventario más sensible de THE GRID. Se requiere la confirmación máxima sin importar la cantidad.",
    },
    statePill: {
      active: "activo",
      sale_pending: "venta pendiente",
      confirming: "confirmando",
      sold: "vendido",
      expired: "expirado",
      cancelled: "cancelado",
      reconciliation_required: "reconciliación requerida",
      open: "abierto",
    },
    errors: {
      unauthenticatedTitle: "Inicio de sesión requerido",
      unauthenticatedHint: "Conecta tu wallet e inicia sesión para autorizar esta acción.",
      disabledTitle: "Mercado en pausa",
      disabledHint: "El settlement no está disponible temporalmente. No se cobró ni se cambió nada — inténtalo de nuevo cuando se reanude.",
      cellLockedTitle: "Reservado por otro comprador",
      cellLockedHint: "Una o más celdas de este parcel están retenidas ahora mismo por la compra pendiente de otro comprador. Inténtalo de nuevo en unos minutos.",
      notActiveTitle: "Ya no está disponible",
      notActiveHint: "Este anuncio ya no está activo — puede que se acabe de vender o retirar. Actualiza para ver lo último.",
      expiredTitle: "Anuncio expirado",
      expiredHint: "Este anuncio ha expirado y ya no se puede comprar. El propietario puede volver a publicarlo.",
      selfTitle: "Este es tu anuncio",
      selfHint: "No puedes comprar ni pujar sobre un activo que ya estás vendiendo.",
      belowFloorTitle: "Por debajo del precio floor",
      belowFloorHint: "El precio cambió y ahora está por debajo del floor del vendedor. Revisa e inténtalo de nuevo.",
      settlementTitle: "Settlement en curso",
      settlementHint: "Ya hay un settlement en curso para este activo. Espera a que finalice antes de volver a intentarlo.",
      reconciliationTitle: "Reconciliación requerida",
      reconciliationHint: "Este activo debe reconciliarse con la chain antes de poder negociarse. No se realizó ninguna acción.",
      spatialTitle: "Conflicto de colocación",
      spatialHint: "Esta obra no está en una colocación liquidable ahora mismo — puede haberse movido o solaparse con otra colocación.",
      bidLowTitle: "Puja demasiado baja",
      bidLowHint: "Tu puja está por debajo de la puja mínima siguiente. Auméntala e inténtalo de nuevo.",
      permitReusedTitle: "Permit ya usado",
      permitReusedHint: "Ese permit de puja ya se gastó. Haz una puja nueva.",
      auctionClosedTitle: "Subasta cerrada",
      auctionClosedHint: "Esta subasta ya no acepta pujas.",
      auctionNotStartedTitle: "Subasta no iniciada",
      auctionNotStartedHint: "Esta subasta todavía no está abierta a pujas.",
      sellerBidTitle: "Los vendedores no pueden pujar",
      sellerBidHint: "No puedes pujar en tu propia subasta.",
      permitRefusedTitle: "Autorización rechazada",
      permitRefusedHint: "La autoridad de settlement se negó a firmar. No se realizó ninguna acción.",
      noBasisTitle: "Origen no registrado",
      noBasisHint: "Este activo aún no tiene un origen de adquisición PAGADO registrado, así que no se puede liquidar. No se realizó ninguna acción.",
      zeroAmountTitle: "Importe requerido",
      zeroAmountHint: "Introduce un importe mayor que cero.",
      genericTitle: "Algo salió mal",
      genericHint: "La acción no se pudo completar. No se cambió nada.",
    },
    tabs: {
      overview: "Resumen",
      land: "Terrenos",
      artworks: "Obras",
      mine: "Mi Mercado",
      owner: "Owner Console",
      ownerAria: "Owner Console — solo admin",
    },
    states: {
      loading: "Cargando…",
      retry: "Reintentar",
      active: "activos",
    },
    paused: {
      title: "Mercado en pausa",
      body: "El settlement no está disponible temporalmente. La navegación sigue abierta; no se puede cobrar nada.",
    },
    mine: {
      signInTitle: "Inicia sesión para ver tu mercado",
      signInHint: "Conecta tu wallet e inicia sesión para ver tus anuncios, ofertas y pujas.",
      connectSignIn: "Conectar e iniciar sesión →",
      loadErrorTitle: "No se pudo cargar tu mercado",
      loadingYours: "Cargando tu mercado…",
      listings: "Mis Anuncios",
      listLand: "Vender Terreno",
      noListings: "Sin anuncios activos",
      noListingsHint: "Pon un parcel en venta desde su página de detalle — o usa Vender Terreno — para venderlo.",
      offersReceived: "Ofertas Recibidas",
      offersMade: "Ofertas Hechas",
      bids: "Mis Pujas",
      noBids: "Sin pujas activas",
      noBidsHint: "Puja en una subasta en vivo para verla aquí.",
      cancel: "Cancelar",
      withdraw: "Retirar",
      noOpenOffers: "Sin ofertas abiertas",
      noOffersReceived: "Sin ofertas recibidas",
      offerMadeHint: "Haz una oferta desde cualquier anuncio u obra.",
      offerReceivedHint: "Las ofertas sobre tus activos aparecerán aquí.",
      accept: "Aceptar",
      decline: "Rechazar",
      accepting: "Aceptando…",
      acceptUnsupported: "Este tipo de oferta aún no se puede aceptar aquí.",
      pendingPurchases: "Compras Pendientes",
      noPendingPurchases: "Sin compras pendientes",
      pendingPurchasesHint: "Las ofertas que un vendedor aceptó aparecerán aquí para completar la compra.",
      completePurchase: "Completar compra",
      auction: "Subasta",
      leading: "Liderando",
      outbid: "Superado",
      bidPrefix: "puja",
      artworkLabel: "Obra",
      sales: "Ventas",
      purchases: "Compras",
      noSales: "Aún no hay ventas",
      noSalesHint: "Las parcelas que vendas en el mercado secundario aparecerán aquí.",
      noPurchases: "Aún no hay compras",
      noPurchasesHint: "Las parcelas que compres en el mercado secundario aparecerán aquí.",
      soldTo: "Vendido a",
      boughtFrom: "Comprado a",
      feeShort: "Comisión",
      netShort: "Neto",
      soldStatus: "Vendido",
      viewTx: "Ver tx →",
    },
    sell: {
      slotsSelected: "Casillas seleccionadas",
      partialBadge: "Área parcial",
      realSelectTitle: "Selecciona el área a vender",
      realSelectHint: "Haz clic o arrastra para seleccionar celdas. Selecciona la parcela completa para publicarla, o un área contigua para una venta parcial.",
      selectWhole: "Seleccionar parcela completa",
      wholeSelectedNote: "Parcela completa seleccionada: se publicará la parcela entera.",
      wholeIneligibleTitle: "Venta de la parcela completa no disponible",
      wholeIneligibleBody: "Parte de esta parcela no es elegible: un bloqueo de mercado activo o contenido canónico (una obra colocada) ocupa una o más celdas. La publicación de la parcela completa está bloqueada hasta que esas celdas queden libres. No se creó ningún anuncio.",
      partialDisabledTitle: "Venta parcial no disponible",
      partialVaultRequired: "La venta de un área parcial requiere un token hijo on-chain de SubdivisionVault para esta parcela, que aún no existe. Crea la subdivisión on-chain antes de publicar esta área. No se creó ninguna publicación.",
      subdivisionTooComplex: "La forma seleccionada supera el límite de subdivisión on-chain ({total}/{max} rectángulos) — ajusta tu selección. No se envió ninguna transacción.",
      subAlreadySubdivided: "Esta parcela ya está subdividida on-chain. La re-subdivisión aún no es compatible.",
      subDepositFailed: "Falló el depósito de la parcela en la bóveda.",
      subSplitFailed: "Falló la división de subdivisión on-chain.",
      subGeometryMismatch: "La geometría del hijo on-chain no coincide con tu selección.",
      sub_plan: "Calculando subdivisión…",
      sub_approve: "Aprobando bóveda…",
      sub_approveCollection: "Aprobando marketplace…",
      nftApprovalFailed: "Falló la aprobación de transferencia al marketplace. No se creó ninguna publicación.",
      sub_deposit: "Depositando parcela…",
      sub_split: "Subdividiendo on-chain…",
      sub_reconcile: "Reconciliando…",
      sub_sign: "Firmar y publicar…",
      wholeTitle: "List the whole parcel",
      wholeSubtitle: "Parcel #{id} · whole parcel",
      wholeBadge: "Whole parcel",
      wholeIntro: "You are authorizing a REAL secondary-market listing of the ENTIRE parcel on Base Sepolia. Your wallet signs an EIP-712 order; nothing is written on-chain until a buyer fills it.",
      wholeConnectRequired: "Connect the owner wallet to authorize this listing.",
      wholeOwnerMismatch: "The connected wallet is not the on-chain owner of this parcel.",
      wholeNotConfigured: "The marketplace contract is not configured for real listings.",
      signAndList: "Sign & list",
      signing: "Awaiting wallet signature…",
      reviewToken: "Token ID",
      reviewCollection: "Collection",
      realCreatedTitle: "Listing authorized",
      realCreatedBody: "Your signed order is live in the marketplace. It settles on-chain only when a buyer fills it.",
      partialFutureTitle: "Sell a subset (partial)",
      partialFutureBody: "Partial sale requires an on-chain subdivision-vault child token, which is not yet available on Base Sepolia. Only whole-parcel listings are possible right now.",
      priceRealHelp: "Set your asking price in {sym}.",
      listLand: "Vender Terreno",
      sellLand: "Vender Terreno",
      sellLandDemo: "Vender Terreno · Preview Demo",
      previewDemo: "Preview Demo",
      previewDemoGrid: "Grid Preview Demo",
      myLand: "Mis Terrenos",
      selectLand: "Seleccionar Terreno",
      pickTitle: "Elige el terreno a vender",
      pickHint: "Selecciona uno de tus parcels para poner en venta un subconjunto contiguo de celdas.",
      pickEmpty: "Sin terreno vendible",
      pickEmptyHint: "No posees terreno disponible para venta parcial en esta preview.",
      pickCells: "{n} celdas",
      pickListed: "{n} activos",
      pickOpen: "Seleccionar área →",
      wizardTitle: "Vender Terreno",
      wizardSubtitle: "Parcel #{id} · Preview Demo",
      stepSelect: "Seleccionar área",
      stepPrice: "Precio",
      stepReview: "Revisar",
      selectTitle: "Selecciona las celdas a vender",
      selectHint: "Haz clic en una celda para alternarla, o clic y arrastra para pintar un rectángulo. La selección debe ser un bloque contiguo y no puede ser el parcel entero.",
      selectedCount: "{n} de {total} celdas seleccionadas",
      clearSelection: "Limpiar",
      valLoading: "Validando…",
      valValid: "Selección válida",
      valInvalid: "Selección no válida",
      basisLabel: "Coste de adquisición",
      floorLabel: "Floor mínimo de reventa (80%)",
      floorBinding: "Vinculante",
      floorNotBinding: "Floor no vinculante (sin basis registrada)",
      reasonOutside: "Las celdas quedan fuera del parcel",
      reasonNotContiguous: "Las celdas deben formar un único bloque contiguo",
      reasonFull: "Es el parcel entero — usa el anuncio de parcel completo",
      reasonNotOwner: "No eres el propietario de este terreno",
      reasonOverlap: "Algunas celdas se solapan con un anuncio existente",
      reasonOccupied: "Algunas celdas están ocupadas por contenido canónico",
      reasonNoBasis: "Precio mínimo de reventa no disponible: no hay base de coste de adquisición registrada para esta parcela.",
      priceTitle: "Fija tu precio",
      priceLabel: "Precio",
      currencyLabel: "Moneda",
      priceHelpFloor: "Debe ser al menos el floor de {floor} {sym}.",
      belowFloor: "El precio está por debajo del floor mínimo de {floor} {sym}.",
      reviewTitle: "Revisar y autorizar",
      reviewCells: "Celdas",
      reviewArea: "Área",
      reviewFloor: "Floor",
      reviewPrice: "Tu precio",
      authorize: "Autorizar y Publicar",
      authorizeDemo: "Autorizar (Preview Demo) y Publicar",
      creating: "Creando anuncio…",
      createdTitle: "Anuncio demo creado",
      createdBody: "Tu anuncio preview demo ya es visible en Mis Anuncios.",
      viewMine: "Ir a Mis Anuncios",
      demoDisclosureTitle: "Preview Demo — sin cambio on-chain / canónico",
      demoDisclosureBody: "Esto publica un parcel demo aislado en el substrate de preview. Tu sesión SIWE autoriza la escritura; no ocurre ningún mint on-chain del SubdivisionVault, ni orden EIP-712, ni settlement en Base Sepolia. En producción este mismo flujo firma con tu wallet y liquida on-chain.",
      back: "Atrás",
      next: "Siguiente",
      close: "Cerrar",
    },
    artworkMkt: {
      buyNow: "Buy now",
      listedAt: "Listed at",
      fixedPrice: "Fixed price",
      yourListing: "Your listing",
      cancelListing: "Cancel listing",
      sellArtwork: "Sell / List Artwork",
      listArtwork: "List / Sell",
      buyTitle: "Buy “{title}”",
      buySubtitle: "Fixed-price artwork settlement",
      buyIntro: "You are buying this artwork at its listed price. Your wallet locks USDC in escrow, then the sale finalizes on-chain. Nothing moves until you confirm.",
      priceLabel: "Price",
      royaltyLabel: "Creator royalty",
      gridFeeLabel: "Grid fee",
      confirmBuy: "Confirm & buy",
      buyPreparing: "Preparing settlement…",
      buyCheckingAllowance: "Checking USDC allowance…",
      buyApprove: "Approve USDC in your wallet…",
      buyApproving: "Approving USDC…",
      buyOpenWallet: "Confirm escrow in your wallet…",
      buyOpening: "Locking funds in escrow…",
      buyIndexingEscrow: "Confirming escrow on-chain…",
      buyAuthorizing: "Authorizing payout…",
      buyReleaseWallet: "Confirm payout in your wallet…",
      buyReleasing: "Releasing payout on-chain…",
      buyIndexingPayout: "Confirming payout finality…",
      buyFinalizing: "Transferring ownership…",
      buyComplete: "Purchase complete",
      buyCompleteBody: "The artwork is now yours. Ownership and listings refresh shortly.",
      buyRejected: "The action was rejected in your wallet.",
      buyReverted: "The transaction reverted on-chain.",
      buyFailed: "Purchase failed",
      connectBuyer: "Connect the buyer wallet {addr} to complete this purchase.",
      sellIntro: "You own this artwork. List it at a fixed price or open a live auction.",
      cancelListingConfirm: "Cancel this listing?",
      listingCancelled: "Listing cancelled.",
      wizardTitle: "Sell Artwork",
      pickTitle: "Choose an artwork to sell",
      pickHint: "Select a frozen, placed artwork you own that isn't already listed or in auction.",
      pickEmpty: "No sellable artworks",
      pickEmptyHint: "You need a frozen artwork placed on the Grid that isn't already listed or auctioned.",
      chooseMode: "How do you want to sell?",
      modeFixed: "Fixed price",
      modeFixedDesc: "List at a set price. Buyers purchase instantly; you sign nothing on-chain.",
      modeAuction: "Auction",
      modeAuctionDesc: "Run a timed English auction with a reserve. You sign the auction creation on-chain.",
      setPrice: "Set your price",
      priceHint: "Set your asking price in {sym}. Grid fee {fee}% + creator royalty {roy}% are deducted on settlement.",
      listBtn: "List for sale",
      listing: "Listing…",
      listedTitle: "Artwork listed",
      listedBody: "Your artwork is now listed at the fixed price. Buyers can purchase it from its detail page.",
      setAuction: "Auction terms",
      reserveLabel: "Reserve price",
      minIncrementLabel: "Minimum bid increment",
      durationLabel: "Duration",
      antiSnipeLabel: "Anti-snipe window",
      dur1h: "1 hour",
      dur6h: "6 hours",
      dur24h: "24 hours",
      dur3d: "3 days",
      dur7d: "7 days",
      antiSnipe60: "60 seconds",
      antiSnipe300: "5 minutes",
      antiSnipeOff: "Off",
      createAuctionBtn: "Create auction",
      creatingAuction: "Creating auction…",
      auctionWalletConfirm: "Confirm auction in your wallet…",
      auctionSubmitting: "Creating auction on-chain…",
      auctionCreatedTitle: "Auction created",
      auctionCreatedBody: "Your auction is live on-chain. Bidders can place bids until it ends.",
      review: "Review",
      reviewArtwork: "Artwork",
      reviewRoyalty: "Royalty",
      reviewMode: "Mode",
      reviewPrice: "Price",
      reviewReserve: "Reserve",
      reviewIncrement: "Increment",
      reviewEnds: "Ends",
      settleAuction: "Settle auction",
      settling: "Settling…",
      settleWalletConfirm: "Confirm settlement in your wallet…",
      settled: "Auction settled",
      cancelAuction: "Cancel auction",
      cancellingAuction: "Cancelling…",
      auctionCancelled: "Auction cancelled.",
      bidPlacedOnchain: "Bid placed on-chain.",
      bidApprove: "Approve USDC in your wallet…",
      bidApproving: "Approving USDC…",
      bidWalletConfirm: "Confirm bid in your wallet…",
      bidSubmitting: "Placing bid on-chain…",
      historyTitle: "History / Provenance",
      historyEmpty: "No sale or auction history yet for this artwork.",
      histPrepared: "Settlement prepared",
      histFinalized: "Sold (fixed price)",
      histAuctionSettled: "Auction settled",
      histFrozen: "Frozen & placed",
      myArtworkListings: "My Artwork Listings",
      noArtworkListings: "No artwork listings",
      noArtworkListingsHint: "List a frozen artwork for sale to see it here.",
      myAuctions: "My Auctions",
      noMyAuctions: "No auctions",
      noMyAuctionsHint: "Create an auction from an artwork you own to see it here.",
      close: "Close",
      cancel: "Cancel",
      back: "Back",
      next: "Next",
      done: "Done",
      viewTx: "View tx →",
      signInFirst: "Connect your wallet & sign in →",
      auctionEnds: "Ends {when}",
    },
    demoGrid: {
      title: "Grid Preview Demo",
      subtitle: "Tu terreno demo · substrate de preview aislado",
      disclosure: "Esta es una superficie PREVIEW DEMO aislada — no la Grid canónica. Nada aquí toca parcels reales, propiedad on-chain ni Base Sepolia.",
      empty: "No tienes terreno demo en esta preview.",
      emptyHint: "Inicia sesión con la wallet demo del vendedor para ver terreno demo vendible.",
      returnToMarket: "← Volver al Marketplace",
      ownedBadge: "Tuyos",
      listedBadge: "{n} en venta",
      clickToSell: "Haz clic en un parcel para vender una parte",
      worldLabel: "Mundo 1000 × 1000",
      loadError: "No se pudo cargar tu terreno demo",
    },
    clock: {
      closing: "cerrando",
      ended: "Finalizada",
    },
    grid: {
      cellAria: "celda {x},{y}",
      cellLockedAria: "celda {x},{y} (bloqueada)",
    },
  },
  purchase: {
    intro: "Vista previa de cotización en vivo — no se cobra nada hasta que confirmes.",
    loading: "cargando…",
    bootstrapError: "No se pudo cargar /sale/config o /sale/status: {error}",
    recovery: {
      confirming: "Se recuperó una compra pendiente — confirmando en Base…",
      syncing: "Confirmado on-chain — sincronizando con la Grid…",
      failed: "La transacción de compra recuperada se revirtió. No se compró ninguna parcela.",
      degraded: "Red temporalmente no disponible — reintentando el estado de la compra…",
    },
    sections: {
      contracts: "Contratos on-chain",
      saleStatus: "Estado de la venta",
      wallet: "Wallet",
      financial: "Saldo y autorización USDC",
      approval: "Autorización USDC",
      purchase: "Compra",
      indexing: "Indexación",
      quote: "Cotización",
    },
    gate: { yes: "SÍ", no: "NO ({reason})" },
    wallet: {
      connect: "Conectar {name}",
      disconnect: "Desconectar",
      wrongChain: "El wallet está en la chain {chainId}, la venta está en la {expectedChainId}. Cambia de red en tu wallet.",
      switching: "Cambiando…",
      switchTo: "Cambiar a la chain {chainId}",
      switchRejected: "cambio rechazado",
      switchError: "error de cambio: {message}",
    },
    financial: {
      blocked: "lecturas deshabilitadas: {reason}",
      readError: "error de lectura",
      noSellableQuote: "— (sin cotización vendible)",
      insufficient: "insufficient_balance (faltan {amount})",
      approval: "approval_required (se necesitan {amount})",
      ready: "ready_for_purchase",
      rpcError: "Error RPC al leer el estado de USDC.",
      refetch: "Recargar saldo/autorización",
    },
    approve: {
      blocked: "autorización deshabilitada: {reason}",
      waitingWallet: "Esperando el wallet…",
      submitting: "Enviando…",
      confirming: "Confirmando…",
      cta: "Autorizar USDC exactos",
      rejected: "El usuario rechazó la transacción de autorización. Puedes intentarlo de nuevo.",
      reverted: "La transacción de autorización se revirtió on-chain.",
      error: "Error de autorización: {error}",
      confirmed: "Autorización confirmada. Se dispararon la recarga de autorización y una nueva cotización forzada.",
    },
    tx: {
      blocked: "compra deshabilitada: {reason}",
      refreshingQuote: "Actualizando la cotización final…",
      awaitingWallet: "Confirma en tu wallet…",
      submitted: "Enviado…",
      confirming: "Confirmando en Base…",
      cta: "Comprar",
      rejected: "El usuario rechazó la transacción de compra.",
      reverted: "Transacción revertida",
      revertedReason: "Transacción revertida: {reason}",
      error: "Error de compra: {error}",
      confirmed: "Transacción confirmada on-chain. Sincronizando con la Grid — esperando la indexación del backend…",
    },
    indexing: {
      pending: "Sincronizando con la Grid…",
      delayed: "Transacción confirmada on-chain. La indexación del backend está tardando más de lo esperado.",
      checkAgain: "Comprobar de nuevo",
      success: "En propiedad · Live. Compra indexada correctamente.",
      buyAnother: "Comprar otra parcela",
      anomaly: "Se detectó una anomalía de indexación ({reason}). La transacción on-chain está confirmada pero el registro indexado no coincide con el snapshot de compra original. Contacta con soporte con el hash de la transacción de abajo.",
    },
    quote: {
      empty: "Dibuja un rectángulo en la cuadrícula para obtener una cotización.",
      clearSelection: "Borrar selección",
      occupiedSelf: "Esta área se solapa con una parcela que ya posees. El terreno ya acuñado no se puede volver a comprar.",
      occupiedOther: "Esta área se solapa con terreno propiedad de otro wallet. Dibuja sobre cuadrícula libre para comprar.",
      occupiedGeneric: "Esta área se solapa con parcelas existentes y no se puede comprar. Dibuja sobre cuadrícula libre.",
      loading: "cargando cotización…",
    },
    errors: {
      tooWide: "Selección demasiado ancha — una sola parcela puede tener como máximo 250 celdas de ancho. Dibuja un área más estrecha.",
      tooHigh: "Selección demasiado alta — una sola parcela puede tener como máximo 250 celdas de alto. Dibuja un área más baja.",
      areaExceeds: "Selección demasiado grande — una sola parcela puede cubrir como máximo 10.000 slots (celdas){yours}. Dibuja un área más pequeña para obtener una cotización.",
      areaExceedsYours: " — la tuya tiene {slots} slots",
      outOfBounds: "La selección sobrepasa el borde de la Grid. Mantenla completamente dentro del territorio 1000 × 1000.",
      zeroOrNegative: "La selección está vacía — dibuja un rectángulo de al menos una celda de ancho.",
      vipCap: "Esta área VIP supera el límite comercial por parcela. Dibuja un área más pequeña.",
      zoneCap: "Esta área supera la capacidad restante de su zona. Dibuja un área más pequeña.",
      unexpected: "Error inesperado.",
    },
  },
  profile: {
    badge: { none: "Aún sin insignia" },
    cockpit: {
      title: "Resumen",
      available: "Disponible",
      pendingFunding: "Financiación pendiente",
      ownedParcels: "Parcelas en propiedad",
      influence: "Influencia",
      lifetimePts: "puntos totales",
      slots: "{n} slots",
      progressTo: "Progreso hacia {badge}",
      max: "máx",
      referralCode: "Código de referido",
      qualified: "{n} cualificados",
      pending: "{n} pendientes",
    },
    myGrid: {
      loading: "Cargando tu cuadrícula…",
      signIn: "Iniciar sesión",
      unavailable: "No disponible.",
      failedToLoad: "Error al cargar",
      retry: "Reintentar",
      title: "Mi Grid",
      empty: "Aún no posees ningún terreno. Adquiere una parcela para empezar a ganar recompensas de Vecindario e Influencia.",
      parcels: "Parcelas",
      totalSlots: "Slots totales",
      clusters: "Clústeres",
      largestCluster: "Clúster más grande",
      slots: "{n} slots",
      parcelMeta: "{w}×{h} · {area} slots",
      edgeNeighbors: "{n} vecinos de borde",
    },
    influence: {
      title: "Puntuación de Influencia",
      lifetimePrivate: "Puntos totales · privado",
      ptsTo: "{points} pts para ",
      maxReached: "Insignia máxima alcanzada",
      nextAt: "siguiente en {threshold}",
      publicNote: "Las superficies públicas muestran solo tu insignia — nunca tu puntuación exacta. Sin clasificación.",
    },
    analytics: {
      title: "Analíticas",
      retry: "Reintentar",
      loadError: "No se pudieron cargar tus analíticas.",
      sections: { land: "Terreno y propiedad", creator: "Creador y referidos", trends: "Tendencias", rewards: "Recompensas e Influencia" },
      kpi: {
        parcelsOwned: "Parcelas en propiedad",
        totalArea: "Área total",
        primaryAcq: "Adquisiciones primarias",
        acqVolume: "Volumen de adquisición",
        ownedTerritories: "Territorios en propiedad",
        publishedTerritories: "Territorios publicados",
        createdArtworks: "Obras creadas",
        qualifiedReferrals: "Referidos cualificados",
        influence: "Influencia",
        rewardsAvailable: "Recompensas disponibles",
        totalRewards: "Recompensas totales",
        pendingFunding: "Financiación pendiente",
      },
      cells: "celdas",
      referralQ: "Cualificaciones de referidos",
      inRange: "{n} en el periodo",
      noReferrals: "Aún no hay referidos cualificados en este periodo.",
      rewardsByType: "Recompensas por tipo",
      influenceGrowth: "Crecimiento de la influencia",
      noInfluence: "Aún no hay influencia en este periodo.",
      notLiveTitle: "Las Recompensas e Influencia aún no están activas.",
      notLiveBody: "Estas métricas se completan automáticamente cuando el programa The Grid Rewards se active. Nada se rastrea ni se estima hasta entonces.",
    },
    activity: {
      title: "Actividad",
      markAll: "Marcar todo como leído ({n})",
      filters: { all: "Todos", rewards: "Recompensas", land: "Terreno", artwork: "Obras", account: "Cuenta" },
      loadError: "No se pudo cargar tu actividad.",
      retry: "Reintentar",
      empty: "Aún no hay actividad. Los eventos relevantes de tu Grid aparecerán aquí.",
      loading: "Cargando…",
      loadMore: "Cargar más",
    },
    rewards: {
      loading: "Cargando recompensas…",
      failedToLoad: "No se pudieron cargar las recompensas",
      auth: { note: "Inicia sesión para ver tu saldo de Recompensas y tus retiros.", cta: "Ir a iniciar sesión" },
      unavailable: "Recompensas no disponibles.",
      retry: "Reintentar",
      errors: {
        belowMin: "El importe está por debajo del mínimo de 350 USDC.",
        exceedsAvailable: "El importe supera tu saldo Disponible.",
        invalidAmount: "Introduce un importe válido.",
        unauthenticated: "Tu sesión expiró — inicia sesión de nuevo.",
        failed: "El retiro falló.",
      },
      balance: {
        title: "Saldo de Recompensas",
        available: "Disponible",
        pendingFunding: "Financiación pendiente",
        awaitingVault: "A la espera de financiación del Vault",
        withdrawalPending: "Retiro pendiente",
        withdrawn: "Retirado",
        expired: "Expirado",
        expiryDeadline: "Fecha de expiración",
        forfeits: "El Disponible se pierde si no se reclama",
        noTimer: "Sin temporizador activo",
      },
      withdraw: {
        title: "Retirar",
        disabledNote: "Necesitas al menos {min} Disponible para retirar. Disponible actual: {available}.",
        amountLabel: "Importe (USDC)",
        gasLabel: "Estimación de gas de red (USDC · opcional)",
        allToggle: "Retirar todo el Disponible ({available})",
        serviceFee: "Comisión de servicio · 2%",
        gasSeparate: "Gas (separado)",
        estimatedNet: "Neto estimado",
        minNote: "Mínimo {min} bruto. Se aplica una comisión de servicio del 2%; el gas de red se cobra por separado y es solo una estimación.",
        belowMin: "Por debajo del mínimo de 350 USDC.",
        exceeds: "Supera tu saldo Disponible.",
        submitting: "Enviando…",
        submit: "Retirar",
        all: "Retirar todo",
        success: "Retiro solicitado — neto {net} (comisión {fee}, gas {gas}).",
      },
      payout: {
        title: "¿Necesitas ayuda para liquidar?",
        body: "Avisa al equipo para que procese tu saldo Disponible ({available}). Esto no crea dinero y nunca omite el orden de financiación.",
        reachTitle: "Alcanza {min} en ganancias Disponibles para solicitar un pago",
        sending: "Enviando…",
        cta: "Solicitar pago",
        minHint: "Alcanza {min} en ganancias Disponibles para solicitar un pago — tienes {available}.",
        alreadyOpen: "Ya hay una solicitud de pago abierta.",
        sent: "Solicitud de pago enviada al equipo.",
        failed: "No se pudo enviar la solicitud.",
      },
      history: {
        title: "Historial de Recompensas",
        empty: "Aún no hay recompensas. Las recompensas de Referido (7%) y Vecindario (3%) aparecen aquí a medida que se adquiere terreno.",
        referralProv: "Referido · {pct}% de {gross}",
        neighborProvEdge: "Vecindario · {edge}/{total} de borde de un pool del {pct}%",
        neighborProvPool: "Vecindario · pool del {pct}%",
        funded: "Financiado",
        pendingFunding: "Financiación pendiente",
        parcels: "parcelas {ids}",
      },
      withdrawals: {
        title: "Retiros",
        pending: "Pendiente",
        withdrawn: "Retirado",
        failed: "Fallido",
        net: "{net} neto",
        gross: "bruto {x}",
        fee: "comisión {x}",
        gas: "gas {x}",
        failureReason: "· {reason} — devuelto al Disponible para reintentar",
      },
    },
  },
  dashboard: {
    publishability: { published: "Publicado", publishable: "Publicable", notPublishable: "No publicable" },
    territory: { fallback: "Territorio {ordinal}" },
    route: {
      title: "Mis territorios",
      subtitle: "Centro de mando del propietario · derivado de tu propiedad real en la Cuadrícula",
      backToGrid: "Volver a la Cuadrícula",
      authTitle: "Autenticación requerida",
      authBody: "Inicia sesión con tu billetera para gestionar tus territorios. Conectar una billetera no es suficiente — se requiere una sesión firmada.",
      signIn: "Iniciar sesión con Ethereum",
      detailEmpty: "Selecciona un territorio para ver su resumen de gestión.",
    },
    list: {
      resolving: "Resolviendo tus territorios…",
      unavailableTitle: "Territorios no disponibles",
      unavailableBody: "Tus datos completos de propiedad no pudieron resolverse en este momento. No se muestra nada parcial. Inténtalo de nuevo en breve.",
      emptyTitle: "Aún no hay territorios",
      emptyBody: "Todavía no posees ninguna propiedad en la Cuadrícula.",
      exploreGrid: "Explorar la Cuadrícula",
    },
    card: {
      area: "Área",
      gpCapacity: "Capacidad GP",
      propertyUnits: "Unidades de propiedad",
      minNote: "Mínimo 400 u² para publicar.",
      unreadTitle: "Un administrador te envió un mensaje de moderación",
      unreadAria: "Mensaje de moderación no leído",
    },
    detail: {
      territoryArea: "Área del territorio",
      gpCapacity: "Capacidad GP",
      propertyUnits: "Unidades de propiedad",
      underlyingUnitIds: "ID de unidades subyacentes",
      location: "Ubicación (límites del mundo)",
      minNote: "Este territorio está por debajo del mínimo de 400 u² requerido para publicar.",
    },
    identity: {
      title: "Identidad del territorio",
      rev: "rev {n}",
      authRequired: "Se requiere una sesión firmada para gestionar la identidad de este territorio.",
      unavailable: "La gestión de identidad solo está disponible para un territorio legítimamente poseído.",
      loading: "Resolviendo el territorio actual…",
      namePlaceholder: "Nombre para mostrar — nombra este territorio",
      saved: "Guardado.",
      saving: "Guardando…",
      saveName: "Guardar nombre",
      editCanvas: "Editar lienzo →",
      saveErrors: {
        STALE_TERRITORY: "Tu territorio cambió desde que se cargó. Se ha actualizado — revisa y guarda de nuevo.",
        IDENTITY_VERSION_CONFLICT: "Esta identidad se actualizó en otro lugar. Se ha actualizado — revisa y guarda de nuevo.",
        IDENTITY_RECONCILIATION_REQUIRED: "Este territorio ahora se fusiona con otro territorio con nombre. Se requiere reconciliación antes de guardar.",
        TERRITORY_NOT_PUBLISHABLE: "Este territorio está por debajo del mínimo de 400 u² requerido para publicar.",
        TERRITORY_NOT_IDENTITY_ELIGIBLE: "La gestión de identidad solo está disponible para un territorio legítimamente poseído.",
        DISPLAY_NAME_INVALID: "Ese nombre no está permitido.",
        UNTRUSTED_ORIGIN: "Esta solicitud fue bloqueada por seguridad. Recarga la página e inténtalo de nuevo.",
        CSRF_REQUIRED: "Faltaba tu token de seguridad. Recarga la página e inténtalo de nuevo.",
        CSRF_INVALID: "Tu token de seguridad caducó. Recarga la página e inténtalo de nuevo.",
        CSRF_FETCH_FAILED: "No se pudo verificar tu sesión. Recarga la página e inténtalo de nuevo.",
        UNAUTHENTICATED: "Tu sesión caducó. Inicia sesión de nuevo para guardar.",
        UNSUPPORTED_MEDIA_TYPE: "Algo salió mal al enviar tu solicitud. Recarga e inténtalo de nuevo.",
        SEED_NOT_OWNED: "Ya no posees este territorio.",
      },
    },
    reconciliation: {
      intro: "Este territorio ahora fusiona {n} territorios con nombre en uno solo. Elige qué identidad sobrevive — las demás quedan reemplazadas. Los nombres no se fusionan.",
      metaOne: "{n} unidad · rev {rev}",
      metaOther: "{n} unidades · rev {rev}",
      reconciling: "Reconciliando…",
      confirmSurvivor: "Confirmar superviviente",
      errors: {
        STALE_TERRITORY: "Tu territorio cambió desde que se cargó. Se ha actualizado — revisa y elige de nuevo.",
        IDENTITY_VERSION_CONFLICT: "Una de estas identidades cambió en otro lugar. Se ha actualizado — revisa y elige de nuevo.",
        RECONCILIATION_NOT_REQUIRED: "Este territorio ya no necesita reconciliación. Se ha actualizado.",
        SURVIVOR_NOT_CANDIDATE: "Esa identidad ya no es elegible. Se ha actualizado.",
        TERRITORY_NOT_PUBLISHABLE: "Este territorio está por debajo del mínimo de 400 u² requerido para publicar.",
        UNTRUSTED_ORIGIN: "Esta solicitud fue bloqueada por seguridad. Recarga la página e inténtalo de nuevo.",
        CSRF_REQUIRED: "Faltaba tu token de seguridad. Recarga la página e inténtalo de nuevo.",
        CSRF_INVALID: "Tu token de seguridad caducó. Recarga la página e inténtalo de nuevo.",
        CSRF_FETCH_FAILED: "No se pudo verificar tu sesión. Recarga la página e inténtalo de nuevo.",
        UNAUTHENTICATED: "Tu sesión caducó. Inicia sesión de nuevo.",
        TRANSACTION_UNAVAILABLE: "El servicio no está disponible brevemente. Inténtalo de nuevo en un momento.",
        SEED_NOT_OWNED: "Ya no posees este territorio.",
      },
    },
    brandImage: {
      title: "Imagen de marca · LOD0",
      rev: "rev {n}",
      desc: "Imagen de mapa opcional para este territorio (PNG · JPEG · WebP, ≤ 5 MiB, ≤ 2048px). Gratis.",
      recommendedPrefix: "Recomendado para tu territorio:",
      size: "{rw} × {rh} px",
      ratioNote: "(proporción {ratio}) — coincide con tu parcela para que el logo no se estire.",
      previewAlt: "Imagen de marca del territorio",
      unsaved: "Vista previa sin guardar — pulsa Guardar para conservarla.",
      empty: "Aún no hay imagen de marca.",
      saved: "Guardado.",
      removed: "Imagen de marca eliminada.",
      authRequired: "Se requiere una sesión firmada para gestionar la imagen de marca.",
      chooseAria: "Elige una imagen de marca",
      replace: "Reemplazar…",
      select: "Seleccionar imagen…",
      saving: "Guardando…",
      save: "Guardar",
      cancel: "Cancelar",
      remove: "Eliminar",
      removeConfirm: "¿Eliminar la imagen de marca?",
      removing: "Eliminando…",
      confirm: "Confirmar",
      keep: "Mantener",
    },
    publish: {
      publishing: "Publicando…",
      republish: "Republicar",
      published: "Publicado",
      publish: "Publicar",
      blockedSave: "Guarda tu borrador antes de publicar",
      stateLabels: {
        UNPUBLISHED: "No publicado",
        PUBLISHED_CURRENT: "Publicado · actual",
        DRAFT_CHANGED: "Publicado · borrador modificado",
        TERRITORY_CHANGED: "Publicado · territorio modificado",
      },
    },
    media: {
      fileTooLarge: "El archivo supera el máximo de 250 MiB.",
      title: "Biblioteca de medios",
      subtitle: "Medios reutilizables de tu billetera · Imagen 10 · GIF 20 (10s) · PDF 25 · Vídeo 250 MiB · Biblioteca 2 GiB",
      working: "Procesando…",
      upload: "Subir",
      used: "{x} usados",
      free: "{free} libres de {total}",
      loading: "Cargando biblioteca…",
      empty: "Aún no hay medios. Sube una imagen, GIF, PDF o vídeo para iniciar tu biblioteca.",
      loadMore: "Cargar más",
      pages: "{n} páginas",
      deleteAria: "Eliminar recurso",
    },
  },
  artist: {
    utility: {
      loading: "Cargando utilidad de la parcela…",
      referral: {
        title: "Referidos",
        yourCode: "Tu código de referido",
        copyLink: "Copiar enlace de referido",
        copied: "Copiado",
        qualified: "Referidos cualificados",
        pending: "Referidos pendientes",
        empty: "Aún no hay referidos. Comparte tu enlace — un referido se cualifica cuando tu invitado realiza su primera adquisición de terreno primario.",
        preparing: "Tu código de referido se está preparando desde la propiedad canónica — vuelve a comprobar en breve.",
        ownToUnlock: "Posee al menos una parcela para desbloquear tu código de referido.",
        wasReferred: "Fuiste referido · estado",
      },
      parcel: {
        title: "Utilidad de la parcela",
        empty: "Actualmente no posees ninguna parcela. Adquiere terreno para desbloquear la utilidad de la parcela.",
        parcels: "Parcelas",
        totalArea: "Área total",
        clusters: "Clústeres",
        largestCluster: "Clúster más grande",
        flagBasicIdentity: "Identidad básica",
        flagPublishable: "Publicable",
        flagPublished: "Publicado",
        flagHasNeighbors: "Tiene vecinos",
        neighbors: "{n} vecinos",
        cluster: "clúster {size} · {area} u²",
      },
      neighborhood: {
        title: "Vecindario",
        empty: "Posee una parcela para ver tu vecindario.",
        edgeNeighbors: "Vecinos de borde",
        connectedClusters: "Clústeres conectados",
        connectedClusterLabel: "Clúster conectado",
        clusterSummary: "{size} parcelas · {area} u²",
        openParcel: "Parcela #{id} — {n} vecino(s) de borde",
        loading: "Cargando…",
        noEdgeNeighbors: "Sin vecinos de borde.",
        yours: "tuyo",
        published: "publicado",
      },
    },
    profile: {
      loading: "Cargando perfil…",
      connectWallet: "Conecta tu billetera",
      connectBody: "Inicia sesión para ver tu perfil de Artista, elegibilidad y Capacidad Creativa.",
      goToSignIn: "Ir a iniciar sesión",
      unavailable: "Perfil no disponible.",
      retry: "Reintentar",
      loadFail: "No se pudo cargar el perfil",
      moderationLabel: "Moderación",
      moderationMsg: "Mensaje del admin",
      moderationAria: "Tienes un mensaje de un administrador — abre Mis territorios para leerlo",
      tabs: { overview: "Resumen", rewards: "Recompensas", activity: "Actividad", analytics: "Analíticas", grid: "Mi Cuadrícula" },
      roleTitle: "Rol",
      roleArtist: "Eres un Artista — una identidad permanente obtenida mediante elegibilidad de terreno y antigüedad.",
      roleNeo: "Eres un NeoArtista — una identidad permanente con acceso acelerado a la creación Artista una vez elegible. Mismas capacidades creativas que un Artista.",
      roleCreator: "Actualmente posees terreno, por lo que puedes usar las herramientas creativas. Creador es un estado actual — sigue tu propiedad de terreno y no es una insignia permanente.",
      roleUser: "Actualmente no posees terreno y no has desbloqueado una identidad artística permanente. Adquiere terreno para convertirte en Creador, o alcanza el 50 % de elegibilidad para la vía NeoArtista.",
      statusCurrentState: "· estado actual",
      eligTitle: "Elegibilidad de Artista",
      neoThreshold: "Umbral NeoArtista · 50%",
      artistThreshold: "Umbral Artista · 100%",
      eligUnits: "{units} / {total} unidades de elegibilidad",
      tierSlots: "{slots} ranuras · {units}u",
      tenureTitle: "Antigüedad de Artista · 100 días",
      tenureBlock: " (bloque {block})",
      tenurePending: "Primera adquisición de terreno registrada on-chain{block}. La fecha exacta se está resolviendo a partir de datos canónicos de la cadena — la antigüedad se mostrará una vez disponible. No se muestra ninguna fecha hasta que pueda probarse.",
      firstAcq: "Primera adquisición: {date}",
      daysLine: "{days} / {min} días",
      reqMet: "requisito cumplido",
      daysRemaining: "{n} días restantes",
      ccTitle: "Capacidad Creativa",
      ccTotal: "Total",
      ccUsed: "Usada",
      ccAvailable: "Disponible",
      ccNote: "La capacidad proviene del terreno que posees y permanece vinculada al historial de cada parcela.",
      neoTitle: "Vía NeoArtista",
      neoHavePermanent: "Ya tienes una identidad permanente {status}.",
      neoNeedElig: "Alcanza el 50% de Elegibilidad de Artista para desbloquear la vía NeoArtista acelerada (actualmente {pct}%).",
      neoEligibleBody: "Eres elegible para la vía NeoArtista acelerada (tarifa única, en USDC o USDT). NeoArtista no otorga Capacidad Creativa adicional.",
      neoFee: "Tarifa: {fee} · {currencies}",
      neoFeeNotConfigured: "Tarifa aún no configurada — no se muestra ningún precio hasta que The Grid lo establezca.",
      neoPaymentPending: "Integración de pago pendiente",
      collectionTitle: "Colección",
      collCreatedBy: "Creado por",
      collOwned: "Poseído",
      collCreatedCount: "{n} creados",
      collCreatedEmpty: "Aún no hay obras congeladas.",
      collOwnedEmpty: "Ninguna obra poseída actualmente.",
      editTitle: "Editar perfil",
      editDisplayName: "Nombre para mostrar",
      editBio: "Biografía",
      editAvatar: "URL del avatar (https/ipfs)",
      editSaving: "Guardando…",
      editSave: "Guardar",
      editSaved: "Guardado",
      editSaveFail: "Error al guardar",
    },
  },
  social: {
    follow: { follow: "Seguir", following: "Siguiendo", actionFailed: "Acción fallida" },
    report: {
      moreOptions: "Más opciones",
      reason: "Motivo",
      report: "Denunciar",
      blockUser: "Bloquear usuario",
      reported: "Denunciado. Gracias.",
      reportFailed: "Error al denunciar",
      blocked: "Bloqueado.",
      blockFailed: "Error al bloquear",
      reasons: {
        spam: "Spam", abuse: "Abuso", harassment: "Acoso", hate: "Odio",
        nsfw: "NSFW", scam: "Estafa", impersonation: "Suplantación", other: "Otro",
      },
    },
    bar: {
      save: "Guardar", saved: "Guardado", comments: "Comentarios",
      likeError: "No se pudo actualizar el me gusta", saveError: "No se pudo actualizar el guardado",
    },
    comment: {
      post: "Publicar", postError: "No se pudo publicar", removed: "[eliminado]", you: "tú",
      reply: "Responder", hide: "Ocultar", viewOne: "Ver {n} respuesta", viewMany: "Ver {n} respuestas",
      delete: "Eliminar", loadingReplies: "Cargando respuestas…", replyPlaceholder: "Escribe una respuesta…",
      heading: "Comentarios", topPlaceholder: "Comparte tu opinión sobre este Territorio…",
      signin: "Inicia sesión para unirte a la conversación →", loading: "Cargando comentarios…",
      empty: "Aún no hay comentarios. Sé el primero.", loadingMore: "Cargando…", loadMore: "Cargar más",
    },
    creator: {
      signinPre: "Inicia sesión", signinPost: "para ver tu perfil.",
      none: "Ningún creador especificado.", loading: "Cargando perfil…", unavailable: "Perfil no disponible.",
      followers: "Seguidores", following: "Siguiendo", likes: "Me gusta", comments: "Comentarios",
      territories: "Territorios", published: "Publicados",
      gotoFeed: "Ir a tu feed →", recentActivity: "Actividad reciente",
    },
    feed: {
      title: "Social", yourProfile: "Tu perfil →",
      following: "Siguiendo", discover: "Descubrir",
      followingSignin: "Inicia sesión para ver a los creadores que sigues →",
      loading: "Cargando feed…", unavailable: "Feed no disponible.",
      emptyFollowing: "Tu feed está tranquilo. Sigue a creadores para ver aquí sus últimos Territorios y obras.",
      emptyDiscover: "Nada que descubrir aún — los nuevos Territorios publicados aparecen aquí.",
      loadingMore: "Cargando…", loadMore: "Cargar más",
      titlePublication: "Publicó un Territorio",
      titleArtworkNamed: "Publicó la obra «{title}»",
      titleArtwork: "Publicó una obra",
      titleAcquiredParcel: "Adquirió la parcela #{id}",
      titleAcquired: "Adquirió un nuevo Territorio",
    },
    handle: {
      heading: "Tu perfil social", handleLabel: "Alias", handlePlaceholder: "tu_alias",
      save: "Guardar", handleSaved: "Alias guardado.", handleError: "No se pudo guardar el alias",
      handleHint: "3–24 caracteres · letras, dígitos, guion bajo · modificable cada 30 días.",
      linksLabel: "Enlaces", linkLabelPlaceholder: "Etiqueta", addLink: "+ Añadir enlace",
      saveLinks: "Guardar enlaces", linksSaved: "Enlaces guardados.", linksError: "No se pudieron guardar los enlaces",
    },
  },
  legal: {
    navAria: "Navegación de documentos legales",
  },
  editor: {
    pixel: {
      title: "Pixel Studio",
      deleteTitle: "Eliminar este pixel art",
      delete: "Eliminar",
      closeTitle: "Cerrar el estudio",
      startingPoint: "Punto de partida",
      startingPointBody: "Convertimos tu imagen en píxeles para darte una base. Ahora hazla tuya…",
      pencil: "Lápiz", eraser: "Goma", fill: "Rellenar", pick: "Cuentagotas",
      undo: "Deshacer", redo: "Rehacer", clear: "Limpiar", grid: "Cuadrícula",
      importOpen: "Importar imagen → Píxel",
      brush: "Pincel", zoom: "Zoom",
      zoomOutTitle: "Zoom − (celdas más pequeñas)", zoomInTitle: "Zoom + (celdas más grandes)",
      cellsPainted: "Celdas pintadas:",
      paletteActive: "Paleta activa", paletteActiveNote: "· imagen importada / dibujo",
      add: "+ Añadir", recent: "Recientes",
      paletteBase: "Paleta base", paletteBaseNote: "· colores estándar THE GRID",
      saving: "Guardando…", saveArtworkCanvas: "Guardar obra + lienzo",
      unsaved: "Sin guardar", saved: "Guardado", close: "Cerrar",
      pixelizeTitle: "Pixelar imagen", cancel: "Cancelar",
      resultingGrid: "Cuadrícula resultante:", colorsLabel: "colores:",
      resolution: "Resolución (lado largo)", fitMode: "Ajuste",
      fitContain: "Contener", fitCover: "Rellenar", maxColors: "Colores máx.",
      dithering: "Tramado", on: "ON", off: "OFF",
      alphaThreshold: "Umbral de transparencia ({v})", useAsBase: "Usar como base",
      unsavedTitle: "Cambios sin guardar",
      unsavedBody: "Tienes cambios de pixel art aún no guardados en el lienzo. ¿Qué quieres hacer?",
      saveAndClose: "Guardar y cerrar", discardClose: "Cerrar sin guardar",
    },
    voxel: {
      invalid: "Ruta del editor 3D no válida.",
      authRequired: "Inicia sesión con tu billetera para editar esta escena 3D.",
      signIn: "Iniciar sesión →",
      loading: "Cargando editor 3D…",
      back: "Volver",
      empty: "Sin territorio.",
      failedToLoad: "Error al cargar",
      noFootprint: "Este territorio no tiene parcelas propias sobre las que construir.",
      flashCreateFirst: "Crea o selecciona primero una Obra",
      flashOutside: "Fuera de tu huella propia",
      flashCleared: "Pieza activa vaciada",
      flashNoImage: "No se pudo leer la imagen",
      flashBaseInside: "La base debe permanecer dentro de tu territorio",
      canvas: "Lienzo",
      add: "Añadir", remove: "Eliminar", cancelBase: "Cancelar base",
      currentColorTitle: "Color actual (cámbialo en la barra lateral)",
      undo: "Deshacer", undoTitle: "Deshacer (Ctrl+Z)",
      redo: "Rehacer", redoTitle: "Rehacer (Ctrl+Mayús+Z)",
      clear: "Limpiar", clearTitle: "Vaciar la pieza activa",
      resetView: "Restablecer vista",
      saving: "Guardando…", saved: "Guardado", save: "Guardar",
      saveTitle: "Guardar borrador 3D", saveOverTitle: "Capacidad superada — elimina vóxeles para guardar",
      publishTitle: "La publicación ocurre en el Lienzo — incluye automáticamente esta escena 3D guardada",
      publishLink: "Publicar en el Lienzo →",
      reload: "Recargar",
      color: "Color", customColorTitle: "Color personalizado",
      workArts: "Obras", newBase: "+ Nueva base",
      budgetLabel: "Presupuesto:", cellsUnit: "celdas",
      noWorkArts: "Aún no hay obras.",
      activePiece: "Pieza activa", rotate: "Rotar", rotationHint: "Restablece la rotación a 0° para editar vóxeles.",
      imageToVoxel: "Imagen → Vóxel", depth: "Profundidad", converting: "Convirtiendo…", chooseImage: "Elegir imagen…",
      conversionHelp: "La conversión te ayuda a empezar con una extrusión simple. Puedes refinar el resultado vóxel a vóxel.",
      fallback: "La edición 3D necesita WebGL, que este dispositivo no pudo iniciar. Tu borrador 3D está a salvo — prueba un navegador de escritorio con aceleración por hardware.",
      defineTitle: "Definir base — arrastra en la cuadrícula",
      defineBody: "Arrastra un rectángulo en el suelo para dimensionar tu pieza, luego suelta para crearla.",
      sizeLabel: "Tamaño", tooBig: "· demasiado grande",
      noCapacityTitle: "Sin capacidad 3D libre",
      noCapacityBody: "Aún no puedes colocar bloques en este territorio. El regalo 3D gratuito (10.000+ vóxeles) solo se concede a la billetera que compró una parcela en la venta primaria y aún la posee. Las parcelas reclamadas/acuñadas o compradas de segunda mano no reciben ninguno.",
      hintNewBase: "Haz clic en «+ Nueva base», luego arrastra en la cuadrícula para dimensionar tu pieza.",
      howToBuild: "Cómo construir",
      step1: "Haz clic en + Nueva base, luego arrastra en la cuadrícula para dimensionar la pieza",
      step2: "Clic izquierdo en el suelo / la cara de un bloque para colocar bloques",
      step3: "Clic derecho en un bloque para eliminarlo",
      mouse: "Ratón", showControls: "Mostrar controles y cómo construir", hide: "Ocultar",
      leftClick: "Clic izquierdo", rightClick: "Clic derecho", ctrlLeft: "Ctrl + izquierdo", ctrlRight: "Ctrl + derecho", scroll: "Rueda",
      drawBase: "Dibujar base", placeBlock: "Colocar bloque", removeBlock: "Eliminar bloque", orbit: "Orbitar alrededor del clic", pan: "Desplazar la vista", zoomInOut: "Acercar / alejar",
      capacity3d: "Capacidad 3D", overCapacity: "Capacidad superada",
    },
    templates: {
      title: "Plantillas de Canvas",
      curatedStarts: "6 puntos de partida seleccionados",
      close: "Cerrar plantillas",
      apply: "Aplicar plantilla",
      previewAria: "Vista previa del diseño de {name}",
      replaceTitle: "¿Reemplazar el borrador actual?",
      replaceBody: "Aplicar {name} reemplazará el contenido de tu borrador actual ({count} {unit}). Tu territorio publicado no se ve afectado hasta que guardes y publiques. Esta acción solo se puede deshacer con Deshacer.",
      elementOne: "elemento",
      elementOther: "elementos",
      cancel: "Cancelar",
      replaceDraft: "Reemplazar borrador",
      catalog: {
        creator: { name: "Creador / Marca personal", useCase: "Identidad personal", tagline: "Una identidad audaz y centrada — nombre, rol, biografía, redes y una única llamada a la acción.", tag0: "Identidad", tag1: "Biografía", tag2: "Redes" },
        retail: { name: "Comercio / Escaparate", useCase: "Marca pequeña y tienda", tagline: "Un encabezado de marca sobre un estante de productos rítmico, con una acción clara de visitar-tienda.", tag0: "Productos", tag1: "Estante", tag2: "Enlace tienda" },
        gallery: { name: "Artista / Galería", useCase: "La obra primero", tagline: "Un único marco dominante con una declaración sobria — la obra guía, las palabras siguen.", tag0: "Obra", tag1: "Declaración", tag2: "Minimal" },
        music: { name: "Música / Evento", useCase: "Lanzamiento y evento en vivo", tagline: "Título lleno de energía, fecha y lugar, y una acción directa de entradas / streaming.", tag0: "Evento", tag1: "Fecha", tag2: "Entradas" },
        product: { name: "Producto / Lanzamiento tech", useCase: "Landing de lanzamiento", tagline: "Una página de lanzamiento moderna — titular, línea de apoyo, tres bloques de funciones y un CTA.", tag0: "Lanzamiento", tag1: "Funciones", tag2: "CTA" },
        minimal: { name: "Lujo minimalista", useCase: "Minimalismo de alta gama", tagline: "Tipografía contenida y espacio generoso — una palabra, una línea, una acción.", tag0: "Lujo", tag1: "Espacio en blanco", tag2: "Contención" },
      },
    },
    error: {
      title: "El lienzo encontró un error",
      body: "El editor se recuperó en lugar de quedarse en negro. Los cambios sin guardar desde tu último guardado no se escribieron en el servidor. Intenta descartar para continuar, o recarga el editor para un estado limpio.",
      dismiss: "Descartar",
      reload: "Recargar editor",
    },
    canvas: {
      invalid: "Ruta de lienzo no válida.",
      authRequired: "Inicia sesión con tu wallet para editar este Lienzo.",
      signIn: "Iniciar sesión →",
      loading: "Cargando el lienzo…",
      empty: "Sin lienzo.",
      failedToLoad: "Error al cargar",
      back: "Atrás",
      close: "Cerrar",
      cancel: "Cancelar",
      exitConfirm: "Tienes cambios sin guardar. ¿Salir sin guardar?",
      flash: {
        saved3d: "Posición 3D guardada",
        territoryChanged3d: "Territorio cambiado — recarga el editor",
        error3d: "3D: {code}",
        rotateOutside: "La rotación saldría del territorio",
      },
      save: {
        territoryChanged: "Territorio cambiado — recargar el editor",
      },
      toolbar: {
        territories: "Territorios",
        undo: "Deshacer",
        redo: "Rehacer",
        fit: "Ajustar territorio",
        templates: "Plantillas",
        templatesTitle: "Empieza desde una plantilla premium",
        templatesDisabledTitle: "Las plantillas requieren un territorio propio",
        mediaLibrary: "Biblioteca de medios",
        mediaLibraryTitle: "Biblioteca de medios — sube y explora sin salir del editor",
        artistProfile: "Perfil de artista",
        artistProfileTitle: "Abre tu perfil de artista",
        editor3d: "Editor 3D",
        editor3dTitle: "Abre el editor de vóxeles 3D para este territorio",
        save: "Guardar",
        saving: "Guardando…",
        saveTitle: "Guardar lienzo",
        saveOverTitle: "Capacidad superada — reduce el uso de GP para guardar",
        freeze: "Congelar",
        freezeTitle: "Congela esta obra de Pixel Studio",
        freezeBlockedTitle: "Guarda el lienzo antes de congelar",
      },
      tools: {
        pixelArt: "Pixel Art",
        new: "NUEVO",
        text: "Texto",
        interactive: "Interactivo",
        media: "Medios",
        shapes: "Formas",
      },
      pixelDraw: {
        banner: "Dibuja un rectángulo en tu territorio",
      },
      pixelSize: {
        title: "Nueva Pixel Art",
        body: "Elige un tamaño de lienzo — 1 celda = 1 parcela. Las celdas vacías quedan transparentes.",
        custom: "Personalizado — dibuja en el territorio",
      },
      mobileReadonly: "Solo lectura / inspección en este dispositivo. La edición requiere una pantalla más grande.",
      gp: {
        used: "Usados",
        available: "Disponibles {n} GP",
        overCapacity: "Capacidad superada",
      },
      status: {
        saved: "Guardado",
        unsavedChanges: "Cambios sin guardar",
        saving: "Guardando…",
        error: "Error",
        showError: "Mostrar el error completo",
      },
      inspector: {
        territoryTiers: "Niveles del territorio",
        globalStyle: "Estilo global",
        background: "Fondo",
        bgColor: "Color de fondo",
        perimeter: "Perímetro",
        perimeterGlow: "Brillo del perímetro",
        opacity: "Opacidad {v}%",
        glow: "Brillo",
        glowColor: "Color del brillo",
        text: "Texto",
        label: "Etiqueta",
        subtitleOptional: "Subtítulo (opcional)",
        urlHttps: "URL (https)",
        previewOpen: "Vista previa / Abrir ↗",
        fill: "Relleno",
        lineColor: "Color de línea",
        fit: "Ajuste",
        pixelArt: "Pixel Art",
        editPixels: "Editar píxeles",
        title: "Título",
        bgPreview: "Vista previa del fondo",
        changeImage: "Cambiar imagen",
        addImage: "+ Añadir imagen",
        selectedGp: "GP {used} / {max} máx",
      },
      controls: {
        preset: "Preajuste",
        layout: "Diseño",
        direction: "Dirección",
        columns: "Columnas {v}",
        align: "Alineación",
        gap: "Espacio {v}",
        iconSize: "Tamaño de icono {v}",
        labelOptional: "Etiqueta (opcional)",
        labelColor: "Color de etiqueta",
        brandColors: "Colores de marca",
        iconColor: "Color de icono",
        backgroundChip: "Chip de fondo",
        bgColor: "Color de fondo",
        border: "Borde",
        borderColor: "Color de borde",
        radius: "Radio",
        padding: "Relleno {v}",
        hover: "Hover",
        font: "Fuente",
        color: "Color",
        textSize: "Tamaño de texto {v}",
        style: "Estilo",
        subtitleColor: "Color de subtítulo",
        underline: "Subrayar etiqueta",
        icon: "Icono",
      },
      social: {
        links: "Enlaces ({n}/5)",
        removeLink: "Eliminar enlace",
        addLink: "+ Añadir enlace",
        showLabels: "Mostrar etiquetas",
        labelFont: "Fuente de etiqueta",
        labelSize: "Tamaño de etiqueta {v}",
      },
      contacts: {
        heading: "Contactos ({n}/10)",
        removeContact: "Eliminar contacto",
        addContact: "+ Añadir contacto",
        show: "Mostrar",
        value: "Valor",
        dataColor: "Color de datos",
        kind: { EMAIL: "Correo", PHONE: "Teléfono", WHATSAPP: "WhatsApp", WEBSITE: "Sitio web", MAP: "Dirección" },
        placeholder: { EMAIL: "nombre@ejemplo.com", PHONE: "+34 600 000 123", WHATSAPP: "+34 600 000 123", WEBSITE: "https://ejemplo.com", MAP: "Calle Mayor 1, Ciudad" },
      },
      layers: {
        title: "Capas",
        empty: "Aún no hay módulos.",
        front: "Al frente",
        forward: "Adelante",
        backward: "Atrás",
        back: "Al fondo",
        hide: "Ocultar",
        lock: "Bloquear",
      },
      mediaPanel: {
        title: "Biblioteca de medios",
        working: "Trabajando…",
        upload: "Subir",
        hint: "Imagen 10 · GIF 20 (10s) · PDF 25 · Vídeo 250 MiB · Biblioteca 2 GiB. Las subidas aparecen al instante en los selectores Añadir medio.",
        loading: "Cargando biblioteca…",
        empty: "Aún no hay medios. Sube una imagen, GIF, PDF o vídeo para empezar tu biblioteca.",
        loadMore: "Cargar más",
        deleteAria: "Eliminar asset",
      },
      mediaPicker: {
        choose: "Elegir {kind} de la biblioteca de medios",
        empty: "Sin assets de {kind}. Sube primero en la biblioteca de medios del panel.",
      },
      mediaKind: { image: "imagen", gif: "GIF", video: "vídeo", pdf: "PDF" },
      errorModal: {
        saveFailed: "Error al guardar",
        gotIt: "Entendido",
      },
      tier: { STANDARD: "Standard", PREMIUM: "Premium", VIP_CORE: "VIP Core", RESERVE: "Reserva", GRID_ZERO: "GRID ZERO" },
      enum: {
        module: { TITLE: "Título", TAGLINE: "Eslogan", DESCRIPTION: "Descripción", LINK: "Enlace", SOCIAL: "Social", CONTACTS: "Contactos", IMAGE: "Imagen", GIF: "GIF", VIDEO: "Vídeo", PDF: "PDF", PIXEL_ART: "Pixel Art", SHAPE: "Forma" },
        shape: { RECTANGLE: "Rectángulo", ROUNDED_RECTANGLE: "Rectángulo redondeado", ELLIPSE: "Elipse", LINE: "Línea" },
        bgMode: { NEUTRAL: "Neutro", SOLID_COLOR: "Color sólido" },
        glow: { OFF: "Apagado", LOW: "Bajo", MEDIUM: "Medio", HIGH: "Alto" },
        direction: { HORIZONTAL: "Horizontal", VERTICAL: "Vertical", GRID: "Cuadrícula" },
        align: { START: "Inicio", CENTER: "Centro", END: "Fin" },
        textAlign: { LEFT: "Izquierda", CENTER: "Centro", RIGHT: "Derecha", JUSTIFY: "Justificado" },
        radius: { SQUARE: "Cuadrado", SLIGHT: "Leve", ROUNDED: "Redondeado", PILL: "Píldora" },
        hover: { NONE: "Ninguno", LIFT: "Elevar", GLOW: "Brillo", SCALE: "Escala" },
        fit: { COVER: "Rellenar", CONTAIN: "Ajustar" },
        contactsDisplay: { ICON: "Icono", ICON_LABEL: "Icono + etiqueta", ICON_DATA: "Icono + datos", BUTTON: "Botón" },
        linkIcon: { NONE: "Ninguno", ARROW: "Flecha", FAVICON: "Favicon" },
        socialPreset: { ICONS_ONLY: "Solo iconos", MINIMAL: "Minimal", BUTTONS: "Botones", CARDS: "Tarjetas" },
        contactsPreset: { ICONS_ONLY: "Solo iconos", BUSINESS: "Negocios", MINIMAL: "Minimal" },
        linkPreset: { TEXT: "Texto", BUTTON: "Botón", OUTLINE: "Contorno", CARD: "Tarjeta" },
      },
    },
  },
};

export default es;
